var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNothingFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 215.822,
    height: 130.208,
    viewBox: "0 0 215.822 130.208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nothingFound",
    transform: "translate(0.001 -0.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-0.001 0.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    d: "M5.728,119.033l204.285.258c13.519-11.222.688-46.093-10.6-52.939-12.155-7.368.771-41.319-17.952-49.589-12.225-5.4-41.089,6.56-49.762-4.639C116.185-7.906,95.215,1.307,76.466,8.686c-23.059,9.077-29.943.642-50.612,13.483C-5.431,41.606,25.3,75.412,11.045,85.416-9.86,100.086,5.235,118.764,5.728,119.033Z",
    transform: "translate(0.001 -0.017)",
    fill: "#9bc1f9",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    d: "M842.645,396.243a3.112,3.112,0,0,0-3.821-2.331,4.579,4.579,0,0,0-5.522-2.455,5.643,5.643,0,0,0-10.161.995,3.844,3.844,0,0,0-1.886-.492,3.892,3.892,0,0,0-3.884,3.9q0,.193.019.379Z",
    transform: "translate(-759.04 -360.967)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    d: "M2647.556,1300.973c-.023-.155-.253-.276-.352-.138s-.1.045-.181.34a8.326,8.326,0,0,1-1.059,2.389,8.5,8.5,0,0,1-2.942,2.758,8.648,8.648,0,0,0,.457-3.4,2.856,2.856,0,0,0-.323-1.252c-.064-.109-.259-.086-.264.034-.029.6.169,1.053.1,2.127a13.734,13.734,0,0,1-3.282,7.184,36.69,36.69,0,0,0-1.285-10.134c-.163-.533-.382-1.041-.592-1.561a.1.1,0,1,0-.183.051c.051.173.6,2.41.642,2.564a40.3,40.3,0,0,1,.9,7.717,17.6,17.6,0,0,1-3.489-6.3c-.207-.671-.322-1.364-.578-2.022-.035-.091-.188-.1-.2,0a10.747,10.747,0,0,0,.884,3.681,17.451,17.451,0,0,0,3.224,5.183c.053.06-.167,15.1-.091,15.289.126.321.719.546.741-.024.008-.232.027-9.376.023-13.611.173-.1.271-.279.684-.806a17.321,17.321,0,0,0,2.426-4.168,8.041,8.041,0,0,0,4.567-4.98c.034-.1.182-.565.2-.668A.784.784,0,0,0,2647.556,1300.973Z",
    transform: "translate(-2446.888 -1206.537)",
    fill: "#0e2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    d: "M2534,1107.594q.055-.7.055-1.436c0-5.439-2.308-9.848-5.156-9.848s-5.157,4.41-5.157,9.848c0,.488.02.967.055,1.436Z",
    transform: "translate(-2343.637 -1018.075)",
    fill: "#184655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    d: "M2615.779,1013.424q.053-.991.054-2.025c0-7.671-2.308-13.889-5.157-13.889s-5.156,6.219-5.156,13.889q0,1.032.054,2.025Z",
    transform: "translate(-2419.581 -926.326)",
    fill: "#3c8f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    d: "M2722.1,1192.944c-.036-.469-.054-.948-.054-1.436,0-5.439,2.309-9.848,5.156-9.848s5.156,4.409,5.156,9.848c0,.487-.019.967-.054,1.436Z",
    transform: "translate(-2527.795 -1097.334)",
    fill: "#3c8f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    d: "M2606.241,1132.694c-.046-.661-.071-1.337-.071-2.025,0-7.672,2.926-13.89,6.537-13.89s6.537,6.218,6.537,13.89c0,.687-.024,1.364-.071,2.025Z",
    transform: "translate(-2420.185 -1037.084)",
    fill: "#184655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    d: "M2521.433,1116.78c-1.8,0-3.417,1.973-4.48,5.067a3.658,3.658,0,0,0-1.713-.437c-3.2,0-5.8,4.41-5.8,9.848,0,.487.021.967.061,1.436h17.672c.041-.661.061-1.337.061-2.025C2527.233,1123,2524.637,1116.78,2521.433,1116.78Z",
    transform: "translate(-2330.358 -1037.084)",
    fill: "#3c8f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    "data-name": "Path 2165",
    d: "M1863.06,433.876a2.327,2.327,0,0,1,2.264-1.812,2.3,2.3,0,0,1,.586.075,3.412,3.412,0,0,1,4.115-1.831,4.2,4.2,0,0,1,7.571.741,2.868,2.868,0,0,1,1.406-.367,2.9,2.9,0,0,1,2.895,2.913c0,.095,0,.189-.013.282Z",
    transform: "translate(-1730.106 -397.696)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    d: "M1447.378,183.539a2.115,2.115,0,0,0-2.6-1.584,3.109,3.109,0,0,0-3.751-1.667,3.833,3.833,0,0,0-6.9.676,2.6,2.6,0,0,0-1.281-.335,2.644,2.644,0,0,0-2.636,2.652,2.522,2.522,0,0,0,.013.258Z",
    transform: "translate(-1328.145 -165.687)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_481",
    "data-name": "Rectangle 481",
    width: 0.462,
    height: 5.416,
    transform: "translate(10.327 108.833)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    d: "M129.253,1389.76l-1.523,10.932h3.046Z",
    transform: "translate(-118.615 -1290.583)",
    fill: "#3c8f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    d: "M129.09,1518.167l2.733-.861-.041-.3-2.646.834Z",
    transform: "translate(-119.878 -1408.752)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    "data-name": "Path 2169",
    d: "M135.83,1473.548l1.811-.571-.041-.3-1.725.544Z",
    transform: "translate(-126.137 -1367.586)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_482",
    "data-name": "Rectangle 482",
    width: 0.696,
    height: 7.712,
    transform: "translate(5.034 107.963)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    d: "M45.861,1303.23l-2.271,18.354h4.542Z",
    transform: "translate(-40.479 -1210.229)",
    fill: "#3c8f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    d: "M55.13,1456.563l3.238,2.777-.125-1.007-3.013-2.583Z",
    transform: "translate(-51.196 -1351.864)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    d: "M62.11,1401.762l1.982.678-.093-.753-1.8-.617Z",
    transform: "translate(-57.678 -1301.086)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2173",
    "data-name": "Path 2173",
    d: "M1181.61,488.358l20.707-7.978,20.064,7.978-18.62.771-21.709-.361Z",
    transform: "translate(-1097.286 -446.1)",
    fill: "#c0321f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2174",
    "data-name": "Path 2174",
    d: "M2230.773,342.274l-8.749-16.524h-9.39l-8.535,16.524Z",
    transform: "translate(-2046.808 -302.505)",
    fill: "#c0321f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_483",
    "data-name": "Rectangle 483",
    width: 26.887,
    height: 77.81,
    transform: "translate(183.965 118.994) rotate(180)",
    fill: "#00b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_484",
    "data-name": "Rectangle 484",
    width: 22.312,
    height: 1.886,
    transform: "translate(184.847 73.126) rotate(180)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_485",
    "data-name": "Rectangle 485",
    width: 22.512,
    height: 11.918,
    transform: "translate(183.964 118.994) rotate(180)",
    fill: "#c0321f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_486",
    "data-name": "Rectangle 486",
    width: 22.312,
    height: 1.886,
    transform: "translate(184.847 107.075) rotate(180)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_487",
    "data-name": "Rectangle 487",
    width: 8.748,
    height: 77.81,
    transform: "translate(165.826 118.994) rotate(180)",
    fill: "#00b9ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2175",
    "data-name": "Path 2175",
    d: "M2495.81,1174.914a1.675,1.675,0,1,0,1.675-1.674A1.675,1.675,0,0,0,2495.81,1174.914Z",
    transform: "translate(-2317.701 -1089.515)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2176",
    "data-name": "Path 2176",
    d: "M2480,1060.992a2.865,2.865,0,0,1,5.6,0V1061h0v6.994H2480V1061h0Z",
    transform: "translate(-2303.019 -983.177)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2177",
    "data-name": "Path 2177",
    d: "M2486.14,1066.6a2.4,2.4,0,0,1,4.726,0v.009h0v6.423h-4.726v-6.423h0Z",
    transform: "translate(-2308.721 -988.646)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_488",
    "data-name": "Rectangle 488",
    width: 0.209,
    height: 9.139,
    transform: "translate(179.893 84.751) rotate(180)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_489",
    "data-name": "Rectangle 489",
    width: 6.901,
    height: 0.582,
    transform: "translate(183.209 85.399) rotate(180)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_490",
    "data-name": "Rectangle 490",
    width: 0.209,
    height: 5.207,
    transform: "translate(182.392 78.902) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_491",
    "data-name": "Rectangle 491",
    width: 0.209,
    height: 5.207,
    transform: "translate(182.392 81.601) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2178",
    "data-name": "Path 2178",
    d: "M2486.14,1069.386v-1.021h0v-.009a2.025,2.025,0,0,1,1.505-1.847l3.221,4.96v3.319h-1.61C2488.368,1073.246,2487.129,1071.092,2486.14,1069.386Z",
    transform: "translate(-2308.721 -990.402)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    d: "M2366.48,1174.914a1.674,1.674,0,1,0,1.674-1.674A1.674,1.674,0,0,0,2366.48,1174.914Z",
    transform: "translate(-2197.6 -1089.515)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    d: "M2350.68,1060.992a2.865,2.865,0,0,1,5.6,0V1061h0v6.994h-5.6V1061h0Z",
    transform: "translate(-2182.927 -983.177)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2181",
    "data-name": "Path 2181",
    d: "M2356.81,1066.6a2.4,2.4,0,0,1,4.727,0v.009h0v6.423h-4.727v-6.423h0Z",
    transform: "translate(-2188.62 -988.646)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_492",
    "data-name": "Rectangle 492",
    width: 0.209,
    height: 9.139,
    transform: "translate(170.663 84.751) rotate(180)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_493",
    "data-name": "Rectangle 493",
    width: 6.901,
    height: 0.582,
    transform: "translate(173.98 85.399) rotate(180)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_494",
    "data-name": "Rectangle 494",
    width: 0.209,
    height: 5.207,
    transform: "translate(173.162 78.902) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_495",
    "data-name": "Rectangle 495",
    width: 0.209,
    height: 5.207,
    transform: "translate(173.162 81.601) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    d: "M2356.81,1069.386v-1.021h0v-.009a2.025,2.025,0,0,1,1.505-1.847l3.218,4.959v3.319h-1.612C2359.036,1073.246,2357.8,1071.092,2356.81,1069.386Z",
    transform: "translate(-2188.62 -990.402)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    d: "M2495.81,1415.024a1.675,1.675,0,1,0,1.675-1.674A1.675,1.675,0,0,0,2495.81,1415.024Z",
    transform: "translate(-2317.701 -1312.49)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    d: "M2480,1301.111a2.865,2.865,0,0,1,5.6,0v.009h0v6.994H2480v-6.994h0Z",
    transform: "translate(-2303.019 -1206.161)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M2486.14,1306.712a2.4,2.4,0,0,1,4.726,0v.009h0v6.423h-4.726v-6.423h0Z",
    transform: "translate(-2308.721 -1211.621)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_496",
    "data-name": "Rectangle 496",
    width: 0.209,
    height: 9.139,
    transform: "translate(179.893 101.886) rotate(180)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_497",
    "data-name": "Rectangle 497",
    width: 6.901,
    height: 0.582,
    transform: "translate(183.209 102.534) rotate(180)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_498",
    "data-name": "Rectangle 498",
    width: 0.209,
    height: 5.207,
    transform: "translate(182.393 96.037) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_499",
    "data-name": "Rectangle 499",
    width: 0.209,
    height: 5.207,
    transform: "translate(182.392 98.736) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    d: "M2486.14,1309.5v-1.021h0v-.009a2.025,2.025,0,0,1,1.505-1.847l3.221,4.96v3.319h-1.61C2488.368,1313.355,2487.129,1311.2,2486.14,1309.5Z",
    transform: "translate(-2308.721 -1213.377)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    d: "M2366.48,1415.024a1.674,1.674,0,1,0,1.674-1.674A1.674,1.674,0,0,0,2366.48,1415.024Z",
    transform: "translate(-2197.6 -1312.49)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    d: "M2350.68,1301.111a2.865,2.865,0,0,1,5.6,0v.009h0v6.994h-5.6v-6.994h0Z",
    transform: "translate(-2182.927 -1206.161)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    d: "M2356.81,1306.712a2.4,2.4,0,0,1,4.727,0v.009h0v6.423h-4.727v-6.423h0Z",
    transform: "translate(-2188.62 -1211.621)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_500",
    "data-name": "Rectangle 500",
    width: 0.209,
    height: 9.139,
    transform: "translate(170.663 101.886) rotate(180)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_501",
    "data-name": "Rectangle 501",
    width: 6.901,
    height: 0.582,
    transform: "translate(173.98 102.534) rotate(180)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_502",
    "data-name": "Rectangle 502",
    width: 0.209,
    height: 5.207,
    transform: "translate(173.162 96.037) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_503",
    "data-name": "Rectangle 503",
    width: 0.209,
    height: 5.207,
    transform: "translate(173.162 98.736) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    d: "M2356.81,1309.5v-1.021h0v-.009a2.024,2.024,0,0,1,1.505-1.847l3.221,4.96v3.319h-1.612C2359.036,1313.355,2357.8,1311.2,2356.81,1309.5Z",
    transform: "translate(-2188.62 -1213.377)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    d: "M2188.541,557.3h18.237v1.515H2176.36V557.3Z",
    transform: "translate(-2021.048 -517.53)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    d: "M2423.5,823.789a2.129,2.129,0,1,0,2.129-2.129A2.129,2.129,0,0,0,2423.5,823.789Z",
    transform: "translate(-2250.551 -763.025)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    d: "M2403.41,678.945c0-1.588,1.594-2.875,3.561-2.875s3.561,1.285,3.561,2.875v.012h0v8.891h-7.122v-8.891h0Z",
    transform: "translate(-2231.894 -627.825)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    d: "M2411.2,686.071a3.051,3.051,0,0,1,6.01,0v.009h0v8.169h-6.01V686.08h0Z",
    transform: "translate(-2239.129 -634.771)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_504",
    "data-name": "Rectangle 504",
    width: 0.265,
    height: 11.621,
    transform: "translate(175.217 59.939) rotate(180)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_505",
    "data-name": "Rectangle 505",
    width: 8.774,
    height: 0.74,
    transform: "translate(179.433 60.764) rotate(180)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_506",
    "data-name": "Rectangle 506",
    width: 0.265,
    height: 6.62,
    transform: "translate(178.394 52.502) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_507",
    "data-name": "Rectangle 507",
    width: 0.265,
    height: 6.62,
    transform: "translate(178.393 55.934) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2195",
    "data-name": "Path 2195",
    d: "M2411.37,689.775v-1.3h0v-.012a2.57,2.57,0,0,1,1.912-2.346l4.094,6.3v4.217h-2.048C2414.2,694.681,2412.628,691.943,2411.37,689.775Z",
    transform: "translate(-2239.287 -637.157)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2196",
    "data-name": "Path 2196",
    d: "M2212.635,342.274c-.2.009,4.8-16.524,4.8-16.524h-4.8l-8.535,16.524Z",
    transform: "translate(-2046.808 -302.505)",
    fill: "#f8c48b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2197",
    "data-name": "Path 2197",
    d: "M2313.666,310.44h6.881v1.515H2309.07V310.44Z",
    transform: "translate(-2144.287 -288.287)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    d: "M2322.116,46.283V46.27l5.177,18.852h-2.952l-2.376.006v0h-5.026Z",
    transform: "translate(-2151.595 -42.969)",
    fill: "#c0321f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    d: "M362.31,342.274l8.748-16.524h9.391l8.534,16.524Z",
    transform: "translate(-336.454 -302.505)",
    fill: "#c0321f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_508",
    "data-name": "Rectangle 508",
    width: 26.887,
    height: 77.81,
    transform: "translate(25.856 41.183)",
    fill: "#00b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_509",
    "data-name": "Rectangle 509",
    width: 22.312,
    height: 1.886,
    transform: "translate(24.972 71.239)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_510",
    "data-name": "Rectangle 510",
    width: 22.512,
    height: 11.918,
    transform: "translate(25.856 107.075)",
    fill: "#c0321f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_511",
    "data-name": "Rectangle 511",
    width: 22.312,
    height: 1.886,
    transform: "translate(24.972 105.189)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_512",
    "data-name": "Rectangle 512",
    width: 8.748,
    height: 77.81,
    transform: "translate(43.994 41.183)",
    fill: "#00b9ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2200",
    "data-name": "Path 2200",
    d: "M400.778,1174.914a1.674,1.674,0,1,1-1.674-1.674A1.674,1.674,0,0,1,400.778,1174.914Z",
    transform: "translate(-369.068 -1089.515)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    d: "M387.261,1060.992a2.865,2.865,0,0,0-5.6,0V1061h0v6.994h5.6V1061h0Z",
    transform: "translate(-354.423 -983.177)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    d: "M392.5,1066.6a2.4,2.4,0,0,0-4.726,0v.009h0v6.423H392.5v-6.423h0Z",
    transform: "translate(-360.097 -988.646)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_513",
    "data-name": "Rectangle 513",
    width: 0.209,
    height: 9.139,
    transform: "translate(29.927 75.611)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_514",
    "data-name": "Rectangle 514",
    width: 6.901,
    height: 0.582,
    transform: "translate(26.611 84.818)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_515",
    "data-name": "Rectangle 515",
    width: 0.209,
    height: 5.207,
    transform: "translate(32.635 78.902) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_516",
    "data-name": "Rectangle 516",
    width: 0.209,
    height: 5.207,
    transform: "translate(32.635 81.601) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    d: "M392.515,1069.386v-1.021h0v-.009a2.025,2.025,0,0,0-1.5-1.847l-3.221,4.959v3.319H389.4C390.289,1073.246,391.529,1071.092,392.515,1069.386Z",
    transform: "translate(-360.116 -990.402)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    "data-name": "Path 2204",
    d: "M530.108,1174.914a1.674,1.674,0,1,1-1.674-1.674A1.674,1.674,0,0,1,530.108,1174.914Z",
    transform: "translate(-489.169 -1089.515)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    d: "M516.6,1060.992a2.865,2.865,0,0,0-5.6,0V1061h0v6.994h5.6V1061h0Z",
    transform: "translate(-474.533 -983.177)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    d: "M521.856,1066.6a2.4,2.4,0,0,0-4.726,0v.009h0v6.423h4.726v-6.423h0Z",
    transform: "translate(-480.226 -988.646)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_517",
    "data-name": "Rectangle 517",
    width: 0.209,
    height: 9.139,
    transform: "translate(39.157 75.611)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_518",
    "data-name": "Rectangle 518",
    width: 6.901,
    height: 0.582,
    transform: "translate(35.84 84.818)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_519",
    "data-name": "Rectangle 519",
    width: 0.209,
    height: 5.207,
    transform: "translate(41.865 78.902) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_520",
    "data-name": "Rectangle 520",
    width: 0.209,
    height: 5.207,
    transform: "translate(41.865 81.601) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    d: "M521.856,1069.386v-1.021h0v-.009a2.025,2.025,0,0,0-1.505-1.847l-3.221,4.959v3.319h1.611C519.628,1073.246,520.869,1071.092,521.856,1069.386Z",
    transform: "translate(-480.226 -990.402)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    d: "M400.778,1415.024a1.674,1.674,0,1,1-1.674-1.674A1.674,1.674,0,0,1,400.778,1415.024Z",
    transform: "translate(-369.068 -1312.49)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    d: "M387.261,1301.111a2.865,2.865,0,0,0-5.6,0v.009h0v6.994h5.6v-6.994h0Z",
    transform: "translate(-354.423 -1206.161)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M392.5,1306.712a2.4,2.4,0,0,0-4.726,0v.009h0v6.423H392.5v-6.423h0Z",
    transform: "translate(-360.097 -1211.621)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_521",
    "data-name": "Rectangle 521",
    width: 0.209,
    height: 9.139,
    transform: "translate(29.927 92.746)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_522",
    "data-name": "Rectangle 522",
    width: 6.901,
    height: 0.582,
    transform: "translate(26.611 101.953)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_523",
    "data-name": "Rectangle 523",
    width: 0.209,
    height: 5.207,
    transform: "translate(32.635 96.037) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_524",
    "data-name": "Rectangle 524",
    width: 0.209,
    height: 5.207,
    transform: "translate(32.635 98.736) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M392.5,1309.5v-1.021h0v-.009a2.024,2.024,0,0,0-1.5-1.847l-3.222,4.96v3.319h1.611C390.271,1313.355,391.511,1311.2,392.5,1309.5Z",
    transform: "translate(-360.097 -1213.377)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    d: "M530.108,1415.024a1.674,1.674,0,1,1-1.674-1.674A1.674,1.674,0,0,1,530.108,1415.024Z",
    transform: "translate(-489.169 -1312.49)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    d: "M516.6,1301.111a2.865,2.865,0,0,0-5.6,0v.009h0v6.994h5.6v-6.994h0Z",
    transform: "translate(-474.533 -1206.161)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    d: "M521.856,1306.712a2.4,2.4,0,0,0-4.726,0v.009h0v6.423h4.726v-6.423h0Z",
    transform: "translate(-480.226 -1211.621)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_525",
    "data-name": "Rectangle 525",
    width: 0.209,
    height: 9.139,
    transform: "translate(39.157 92.746)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_526",
    "data-name": "Rectangle 526",
    width: 6.901,
    height: 0.582,
    transform: "translate(35.84 101.953)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_527",
    "data-name": "Rectangle 527",
    width: 0.209,
    height: 5.207,
    transform: "translate(41.865 96.037) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_528",
    "data-name": "Rectangle 528",
    width: 0.209,
    height: 5.207,
    transform: "translate(41.865 98.736) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    d: "M521.856,1309.5v-1.021h0v-.009a2.025,2.025,0,0,0-1.505-1.847l-3.221,4.96v3.319h1.611C519.628,1313.355,520.869,1311.2,521.856,1309.5Z",
    transform: "translate(-480.226 -1213.377)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M355.8,557.3H337.56v1.515h30.418V557.3Z",
    transform: "translate(-313.471 -517.53)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M461.258,823.789a2.129,2.129,0,1,1-2.129-2.129,2.129,2.129,0,0,1,2.129,2.129Z",
    transform: "translate(-424.387 -763.025)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M444.081,678.945c0-1.588-1.594-2.875-3.56-2.875s-3.561,1.285-3.561,2.875v.012h0v8.891h7.121v-8.891h0Z",
    transform: "translate(-405.777 -627.825)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M450.8,686.071a3.051,3.051,0,0,0-6.01,0v.009h0v8.169h6.01V686.08h0Z",
    transform: "translate(-413.048 -634.771)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_529",
    "data-name": "Rectangle 529",
    width: 0.265,
    height: 11.621,
    transform: "translate(34.603 48.318)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_530",
    "data-name": "Rectangle 530",
    width: 8.774,
    height: 0.74,
    transform: "translate(30.387 60.024)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_531",
    "data-name": "Rectangle 531",
    width: 0.265,
    height: 6.62,
    transform: "translate(38.047 52.502) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_532",
    "data-name": "Rectangle 532",
    width: 0.265,
    height: 6.62,
    transform: "translate(38.046 55.934) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M450.646,689.775v-1.3h0v-.012a2.571,2.571,0,0,0-1.913-2.346l-4.093,6.3v4.217h2.047C447.815,694.681,449.391,691.943,450.646,689.775Z",
    transform: "translate(-412.909 -637.157)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M553.992,342.274c.2.009-4.8-16.524-4.8-16.524h4.8l8.534,16.524Z",
    transform: "translate(-509.998 -302.505)",
    fill: "#f8c48b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    d: "M477.151,310.44H470.27v1.515h11.477V310.44Z",
    transform: "translate(-436.71 -288.287)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M483.318,46.283V46.27L478.14,65.122h2.952l2.376.006v0h5.025Z",
    transform: "translate(-444.018 -42.969)",
    fill: "#c0321f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M752.64,730.191V714.87H667.066l-4.476,15.321h90.05Z",
    transform: "translate(-615.305 -663.856)",
    fill: "#c0321f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M1799.04,730.191V714.87h29.735l4.455,15.321h-34.19Z",
    transform: "translate(-1670.655 -663.856)",
    fill: "#c0321f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_533",
    "data-name": "Rectangle 533",
    width: 108.389,
    height: 2.327,
    transform: "translate(50.816 49.851)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_534",
    "data-name": "Rectangle 534",
    width: 34.364,
    height: 52.404,
    transform: "translate(162.575 119.297) rotate(180)",
    fill: "#00b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_535",
    "data-name": "Rectangle 535",
    width: 34.364,
    height: 52.404,
    transform: "translate(47.28 66.892)",
    fill: "#00b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_536",
    "data-name": "Rectangle 536",
    width: 46.749,
    height: 51.486,
    transform: "translate(81.644 67.81)",
    fill: "#00b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_537",
    "data-name": "Rectangle 537",
    width: 209.136,
    height: 0.564,
    transform: "translate(1.372 118.993)",
    fill: "#184655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    d: "M714.747,929.56H644.04v1.515H761.974V929.56Z",
    transform: "translate(-598.079 -863.225)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M743.464,1544.3v5.177H697.916V1544.3h-35.4v8.828h115.3V1544.3Z",
    transform: "translate(-615.24 -1434.095)",
    fill: "#c0321f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_538",
    "data-name": "Rectangle 538",
    width: 5.137,
    height: 46.786,
    transform: "translate(111.812 67.829)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_539",
    "data-name": "Rectangle 539",
    width: 7.464,
    height: 2.341,
    transform: "translate(110.648 67.829)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_540",
    "data-name": "Rectangle 540",
    width: 6.501,
    height: 1.495,
    transform: "translate(111.13 113.12)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_541",
    "data-name": "Rectangle 541",
    width: 5.778,
    height: 0.952,
    transform: "translate(111.491 77.574)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_542",
    "data-name": "Rectangle 542",
    width: 5.778,
    height: 0.952,
    transform: "translate(111.491 81.419)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_543",
    "data-name": "Rectangle 543",
    width: 5.778,
    height: 0.952,
    transform: "translate(111.491 101.443)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_544",
    "data-name": "Rectangle 544",
    width: 5.778,
    height: 0.952,
    transform: "translate(111.491 105.288)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_545",
    "data-name": "Rectangle 545",
    width: 6.059,
    height: 41.533,
    transform: "translate(72.646 67.949)",
    fill: "#f8c48b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_546",
    "data-name": "Rectangle 546",
    width: 6.059,
    height: 41.533,
    transform: "translate(131.355 67.949)",
    fill: "#f8c48b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_547",
    "data-name": "Rectangle 547",
    width: 5.137,
    height: 46.786,
    transform: "translate(92.892 67.933)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_548",
    "data-name": "Rectangle 548",
    width: 7.464,
    height: 2.341,
    transform: "translate(91.728 67.933)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_549",
    "data-name": "Rectangle 549",
    width: 6.501,
    height: 1.495,
    transform: "translate(92.209 113.225)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_550",
    "data-name": "Rectangle 550",
    width: 5.778,
    height: 0.952,
    transform: "translate(92.57 77.678)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_551",
    "data-name": "Rectangle 551",
    width: 5.778,
    height: 0.952,
    transform: "translate(92.57 81.524)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_552",
    "data-name": "Rectangle 552",
    width: 5.778,
    height: 0.952,
    transform: "translate(92.57 101.548)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_553",
    "data-name": "Rectangle 553",
    width: 5.778,
    height: 0.952,
    transform: "translate(92.57 105.393)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_554",
    "data-name": "Rectangle 554",
    width: 63.805,
    height: 2.448,
    transform: "translate(73.088 116.586)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_555",
    "data-name": "Rectangle 555",
    width: 58.749,
    height: 2.408,
    transform: "translate(75.616 114.178)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_556",
    "data-name": "Rectangle 556",
    width: 33.107,
    height: 2.047,
    transform: "translate(45.96 109.483)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_557",
    "data-name": "Rectangle 557",
    width: 33.107,
    height: 2.047,
    transform: "translate(130.914 109.483)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M1442.922,1207.531a2.141,2.141,0,1,1-2.141-2.141A2.141,2.141,0,0,1,1442.922,1207.531Z",
    transform: "translate(-1335.974 -1119.371)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M1425.661,1061.9c0-1.6-1.6-2.891-3.58-2.891s-3.58,1.294-3.58,2.891v.012h0v8.943h7.161v-8.943h0Z",
    transform: "translate(-1317.271 -983.437)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M1432.363,1069.024a3.068,3.068,0,0,0-6.043,0v.011h0v8.213h6.043v-8.21h0Z",
    transform: "translate(-1324.533 -990.383)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_558",
    "data-name": "Rectangle 558",
    width: 0.267,
    height: 11.684,
    transform: "translate(104.668 75.647)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_559",
    "data-name": "Rectangle 559",
    width: 8.822,
    height: 0.744,
    transform: "translate(100.428 87.417)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_560",
    "data-name": "Rectangle 560",
    width: 0.268,
    height: 6.657,
    transform: "translate(108.13 79.854) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_561",
    "data-name": "Rectangle 561",
    width: 0.268,
    height: 6.657,
    transform: "translate(108.13 83.304) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M714.54,1174.914a1.675,1.675,0,1,1-1.674-1.674,1.675,1.675,0,0,1,1.674,1.674Z",
    transform: "translate(-660.437 -1089.515)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M701.041,1060.992a2.865,2.865,0,0,0-5.6,0V1061h0v6.994h5.6V1061h0Z",
    transform: "translate(-645.811 -983.177)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    d: "M706.3,1066.6a2.4,2.4,0,0,0-4.726,0v.009h0v6.423H706.3v-6.423h0Z",
    transform: "translate(-651.504 -988.646)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_562",
    "data-name": "Rectangle 562",
    width: 0.209,
    height: 9.139,
    transform: "translate(52.319 75.611)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_563",
    "data-name": "Rectangle 563",
    width: 6.901,
    height: 0.582,
    transform: "translate(49.003 84.818)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_564",
    "data-name": "Rectangle 564",
    width: 0.209,
    height: 5.207,
    transform: "translate(55.028 78.902) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_565",
    "data-name": "Rectangle 565",
    width: 0.209,
    height: 5.207,
    transform: "translate(55.027 81.601) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    d: "M706.3,1069.386v-1.021h0v-.009a2.025,2.025,0,0,0-1.505-1.847l-3.221,4.959v3.319h1.611C704.068,1073.246,705.312,1071.092,706.3,1069.386Z",
    transform: "translate(-651.504 -990.402)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    d: "M856.178,1174.914a1.674,1.674,0,1,1-1.674-1.674A1.674,1.674,0,0,1,856.178,1174.914Z",
    transform: "translate(-791.969 -1089.515)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    d: "M842.671,1060.992a2.865,2.865,0,0,0-5.6,0V1061h0v6.994h5.6V1061h0Z",
    transform: "translate(-777.334 -983.177)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    "data-name": "Path 2237",
    d: "M847.917,1066.6a2.4,2.4,0,0,0-4.727,0v.009h0v6.423h4.727v-6.423h0Z",
    transform: "translate(-783.017 -988.646)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_566",
    "data-name": "Rectangle 566",
    width: 0.209,
    height: 9.139,
    transform: "translate(62.426 75.611)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_567",
    "data-name": "Rectangle 567",
    width: 6.901,
    height: 0.582,
    transform: "translate(59.11 84.818)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_568",
    "data-name": "Rectangle 568",
    width: 0.209,
    height: 5.207,
    transform: "translate(65.134 78.902) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_569",
    "data-name": "Rectangle 569",
    width: 0.209,
    height: 5.207,
    transform: "translate(65.134 81.601) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    "data-name": "Path 2238",
    d: "M847.917,1069.386v-1.021h0v-.009a2.025,2.025,0,0,0-1.505-1.847l-3.222,4.959v3.319H844.8C845.689,1073.246,846.929,1071.092,847.917,1069.386Z",
    transform: "translate(-783.017 -990.402)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M997.79,1174.914a1.675,1.675,0,1,1-1.674-1.674,1.675,1.675,0,0,1,1.674,1.674Z",
    transform: "translate(-923.474 -1089.515)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M984.292,1060.992a2.865,2.865,0,0,0-5.6,0V1061h0v6.994h5.6V1061h0A.059.059,0,0,0,984.292,1060.992Z",
    transform: "translate(-908.847 -983.177)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M989.546,1066.6a2.4,2.4,0,0,0-4.726,0v.009h0v6.423h4.726v-6.423h0Z",
    transform: "translate(-914.54 -988.646)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_570",
    "data-name": "Rectangle 570",
    width: 0.209,
    height: 9.139,
    transform: "translate(72.533 75.611)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_571",
    "data-name": "Rectangle 571",
    width: 6.901,
    height: 0.582,
    transform: "translate(69.216 84.818)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_572",
    "data-name": "Rectangle 572",
    width: 0.209,
    height: 5.207,
    transform: "translate(75.241 78.902) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_573",
    "data-name": "Rectangle 573",
    width: 0.209,
    height: 5.207,
    transform: "translate(75.241 81.601) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M989.546,1069.386v-1.021h0v-.009a2.025,2.025,0,0,0-1.505-1.847l-3.221,4.959v3.319h1.611C987.318,1073.246,988.559,1071.092,989.546,1069.386Z",
    transform: "translate(-914.54 -990.402)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M714.54,1409.554a1.675,1.675,0,1,1-1.674-1.674A1.675,1.675,0,0,1,714.54,1409.554Z",
    transform: "translate(-660.437 -1307.41)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M701.041,1295.632a2.865,2.865,0,0,0-5.6,0v.009h0v6.994h5.6v-6.994h0Z",
    transform: "translate(-645.811 -1201.072)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M706.3,1301.212a2.4,2.4,0,0,0-4.726,0v.009h0v6.423H706.3v-6.423h0Z",
    transform: "translate(-651.504 -1206.514)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_574",
    "data-name": "Rectangle 574",
    width: 0.209,
    height: 9.139,
    transform: "translate(52.319 92.356)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_575",
    "data-name": "Rectangle 575",
    width: 6.901,
    height: 0.582,
    transform: "translate(49.003 101.562)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_576",
    "data-name": "Rectangle 576",
    width: 0.209,
    height: 5.207,
    transform: "translate(55.028 95.646) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_577",
    "data-name": "Rectangle 577",
    width: 0.209,
    height: 5.207,
    transform: "translate(55.028 98.345) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M706.3,1304v-1.02h0v-.011a2.025,2.025,0,0,0-1.505-1.847l-3.221,4.96v3.319h1.611C704.068,1307.858,705.311,1305.7,706.3,1304Z",
    transform: "translate(-651.504 -1208.269)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M856.178,1409.554a1.674,1.674,0,1,1-1.674-1.674A1.674,1.674,0,0,1,856.178,1409.554Z",
    transform: "translate(-791.969 -1307.41)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    d: "M842.671,1295.632a2.865,2.865,0,0,0-5.6,0v.009h0v6.994h5.6v-6.994h0Z",
    transform: "translate(-777.334 -1201.072)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    d: "M847.917,1301.212a2.4,2.4,0,0,0-4.727,0v.009h0v6.423h4.727v-6.423h0Z",
    transform: "translate(-783.017 -1206.514)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_578",
    "data-name": "Rectangle 578",
    width: 0.209,
    height: 9.139,
    transform: "translate(62.426 92.356)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_579",
    "data-name": "Rectangle 579",
    width: 6.901,
    height: 0.582,
    transform: "translate(59.11 101.562)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_580",
    "data-name": "Rectangle 580",
    width: 0.209,
    height: 5.207,
    transform: "translate(65.134 95.646) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_581",
    "data-name": "Rectangle 581",
    width: 0.209,
    height: 5.207,
    transform: "translate(65.134 98.345) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M847.917,1304.026v-1.02h0V1303a2.025,2.025,0,0,0-1.505-1.847l-3.222,4.96v3.319H844.8C845.689,1307.886,846.929,1305.731,847.917,1304.026Z",
    transform: "translate(-783.017 -1208.297)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    d: "M997.79,1409.554a1.675,1.675,0,1,1-1.674-1.674A1.675,1.675,0,0,1,997.79,1409.554Z",
    transform: "translate(-923.474 -1307.41)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    "data-name": "Path 2252",
    d: "M984.292,1295.632a2.865,2.865,0,0,0-5.6,0v.009h0v6.994h5.6v-6.994h0A.057.057,0,0,0,984.292,1295.632Z",
    transform: "translate(-908.847 -1201.072)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    d: "M989.546,1301.212a2.4,2.4,0,0,0-4.726,0v.009h0v6.423h4.726v-6.423h0Z",
    transform: "translate(-914.54 -1206.514)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_582",
    "data-name": "Rectangle 582",
    width: 0.209,
    height: 9.139,
    transform: "translate(72.533 92.356)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_583",
    "data-name": "Rectangle 583",
    width: 6.901,
    height: 0.582,
    transform: "translate(69.216 101.562)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_584",
    "data-name": "Rectangle 584",
    width: 0.209,
    height: 5.207,
    transform: "translate(75.241 95.646) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_585",
    "data-name": "Rectangle 585",
    width: 0.209,
    height: 5.207,
    transform: "translate(75.241 98.345) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    "data-name": "Path 2254",
    d: "M989.546,1304v-1.02h0v-.011a2.025,2.025,0,0,0-1.505-1.847l-3.221,4.96v3.319h1.611C987.318,1307.858,988.559,1305.7,989.546,1304Z",
    transform: "translate(-914.54 -1208.269)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    "data-name": "Path 2255",
    d: "M1904.428,1174.914a1.674,1.674,0,1,1-1.674-1.674A1.674,1.674,0,0,1,1904.428,1174.914Z",
    transform: "translate(-1765.413 -1089.515)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    "data-name": "Path 2256",
    d: "M1890.921,1060.992a2.864,2.864,0,0,0-5.6,0V1061h0v6.994h5.6V1061h0Z",
    transform: "translate(-1750.777 -983.177)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    "data-name": "Path 2257",
    d: "M1896.164,1066.6a2.4,2.4,0,0,0-4.727,0,.025.025,0,0,0,0,.009h0v6.423h4.727v-6.423h0Z",
    transform: "translate(-1756.457 -988.646)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_586",
    "data-name": "Rectangle 586",
    width: 0.209,
    height: 9.139,
    transform: "translate(137.232 75.611)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_587",
    "data-name": "Rectangle 587",
    width: 6.901,
    height: 0.582,
    transform: "translate(133.916 84.818)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_588",
    "data-name": "Rectangle 588",
    width: 0.209,
    height: 5.207,
    transform: "translate(139.941 78.902) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_589",
    "data-name": "Rectangle 589",
    width: 0.209,
    height: 5.207,
    transform: "translate(139.941 81.601) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    d: "M1896.167,1069.386v-1.021h0v-.009a2.025,2.025,0,0,0-1.505-1.847l-3.222,4.959v3.319h1.61C1893.939,1073.246,1895.179,1071.092,1896.167,1069.386Z",
    transform: "translate(-1756.46 -990.402)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    d: "M1682.86,1174.914a1.675,1.675,0,1,1-1.674-1.674,1.675,1.675,0,0,1,1.674,1.674Z",
    transform: "translate(-1559.655 -1089.515)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2260",
    "data-name": "Path 2260",
    d: "M1669.361,1060.992a2.865,2.865,0,0,0-5.6,0V1061h0v6.994h5.6V1061h0Z",
    transform: "translate(-1545.028 -983.177)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2261",
    "data-name": "Path 2261",
    d: "M1674.616,1066.6a2.4,2.4,0,0,0-4.726,0v.009h0v6.423h4.726v-6.423h0Z",
    transform: "translate(-1550.721 -988.646)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_590",
    "data-name": "Rectangle 590",
    width: 0.209,
    height: 9.139,
    transform: "translate(121.422 75.611)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_591",
    "data-name": "Rectangle 591",
    width: 6.901,
    height: 0.582,
    transform: "translate(118.106 84.818)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_592",
    "data-name": "Rectangle 592",
    width: 0.209,
    height: 5.207,
    transform: "translate(124.13 78.902) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_593",
    "data-name": "Rectangle 593",
    width: 0.209,
    height: 5.207,
    transform: "translate(124.13 81.601) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2262",
    "data-name": "Path 2262",
    d: "M1674.616,1069.386v-1.021h0v-.009a2.025,2.025,0,0,0-1.5-1.847l-3.221,4.959v3.319h1.611C1672.388,1073.246,1673.629,1071.092,1674.616,1069.386Z",
    transform: "translate(-1550.721 -990.402)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2263",
    "data-name": "Path 2263",
    d: "M1682.86,1418.4a1.675,1.675,0,1,1-1.674-1.675A1.675,1.675,0,0,1,1682.86,1418.4Z",
    transform: "translate(-1559.655 -1315.619)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2264",
    "data-name": "Path 2264",
    d: "M1669.361,1304.481a2.865,2.865,0,0,0-5.6,0v.01h0v6.994h5.6v-6.994h0Z",
    transform: "translate(-1545.028 -1209.29)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2265",
    "data-name": "Path 2265",
    d: "M1674.616,1310.083a2.4,2.4,0,0,0-4.726,0v.008h0v6.423h4.726v-6.423h0Z",
    transform: "translate(-1550.721 -1214.751)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_594",
    "data-name": "Rectangle 594",
    width: 0.209,
    height: 9.139,
    transform: "translate(121.422 92.987)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_595",
    "data-name": "Rectangle 595",
    width: 6.901,
    height: 0.582,
    transform: "translate(118.106 102.193)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_596",
    "data-name": "Rectangle 596",
    width: 0.209,
    height: 5.207,
    transform: "translate(124.129 96.278) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_597",
    "data-name": "Rectangle 597",
    width: 0.209,
    height: 5.207,
    transform: "translate(124.129 98.977) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2266",
    "data-name": "Path 2266",
    d: "M1674.616,1312.885v-1.021h0v-.008a2.025,2.025,0,0,0-1.5-1.847l-3.221,4.96v3.317h1.611C1672.388,1316.745,1673.629,1314.591,1674.616,1312.885Z",
    transform: "translate(-1550.721 -1216.525)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2267",
    "data-name": "Path 2267",
    d: "M1216.148,1174.914a1.674,1.674,0,1,1-1.674-1.674A1.674,1.674,0,0,1,1216.148,1174.914Z",
    transform: "translate(-1126.251 -1089.515)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2268",
    "data-name": "Path 2268",
    d: "M1202.631,1060.992a2.865,2.865,0,0,0-5.6,0V1061h0v6.994h5.6V1061h0Z",
    transform: "translate(-1111.606 -983.177)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2269",
    "data-name": "Path 2269",
    d: "M1207.886,1066.6a2.4,2.4,0,0,0-4.726,0v.009h0v6.423h4.726v-6.423h0Z",
    transform: "translate(-1117.299 -988.646)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_598",
    "data-name": "Rectangle 598",
    width: 0.209,
    height: 9.139,
    transform: "translate(88.115 75.611)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_599",
    "data-name": "Rectangle 599",
    width: 6.901,
    height: 0.582,
    transform: "translate(84.798 84.818)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_600",
    "data-name": "Rectangle 600",
    width: 0.209,
    height: 5.207,
    transform: "translate(90.823 78.902) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_601",
    "data-name": "Rectangle 601",
    width: 0.209,
    height: 5.207,
    transform: "translate(90.823 81.601) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2270",
    "data-name": "Path 2270",
    d: "M1207.886,1069.386v-1.021h0v-.009a2.024,2.024,0,0,0-1.505-1.847l-3.221,4.959v3.319h1.611C1205.658,1073.246,1206.9,1071.092,1207.886,1069.386Z",
    transform: "translate(-1117.299 -990.402)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2271",
    "data-name": "Path 2271",
    d: "M1216.148,1418.4a1.674,1.674,0,1,1-1.674-1.675A1.674,1.674,0,0,1,1216.148,1418.4Z",
    transform: "translate(-1126.251 -1315.619)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2272",
    "data-name": "Path 2272",
    d: "M1202.6,1304.481a2.866,2.866,0,0,0-5.6,0v.01h0v6.994h5.6v-6.994h0Z",
    transform: "translate(-1111.578 -1209.29)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2273",
    "data-name": "Path 2273",
    d: "M1207.886,1310.083a2.4,2.4,0,0,0-4.726,0v.008h0v6.423h4.726v-6.423h0Z",
    transform: "translate(-1117.299 -1214.751)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_602",
    "data-name": "Rectangle 602",
    width: 0.209,
    height: 9.139,
    transform: "translate(88.115 92.987)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_603",
    "data-name": "Rectangle 603",
    width: 6.901,
    height: 0.582,
    transform: "translate(84.798 102.193)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_604",
    "data-name": "Rectangle 604",
    width: 0.209,
    height: 5.207,
    transform: "translate(90.822 96.278) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_605",
    "data-name": "Rectangle 605",
    width: 0.209,
    height: 5.207,
    transform: "translate(90.822 98.976) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2274",
    "data-name": "Path 2274",
    d: "M1207.886,1312.885v-1.021h0v-.008a2.024,2.024,0,0,0-1.505-1.847l-3.221,4.96v3.317h1.611C1205.658,1316.745,1206.9,1314.591,1207.886,1312.885Z",
    transform: "translate(-1117.299 -1216.525)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    "data-name": "Path 2275",
    d: "M2046.04,1174.914a1.675,1.675,0,1,1-1.675-1.674,1.675,1.675,0,0,1,1.675,1.674Z",
    transform: "translate(-1896.917 -1089.515)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    "data-name": "Path 2276",
    d: "M2032.541,1060.992a2.865,2.865,0,0,0-5.6,0V1061h0v6.994h5.6V1061h0Z",
    transform: "translate(-1882.291 -983.177)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2277",
    "data-name": "Path 2277",
    d: "M2037.8,1066.6a2.4,2.4,0,0,0-4.726,0v.009h0v6.423h4.726v-6.423h0Z",
    transform: "translate(-1887.983 -988.646)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_606",
    "data-name": "Rectangle 606",
    width: 0.209,
    height: 9.139,
    transform: "translate(147.34 75.611)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_607",
    "data-name": "Rectangle 607",
    width: 6.901,
    height: 0.582,
    transform: "translate(144.023 84.818)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_608",
    "data-name": "Rectangle 608",
    width: 0.209,
    height: 5.207,
    transform: "translate(150.048 78.902) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_609",
    "data-name": "Rectangle 609",
    width: 0.209,
    height: 5.207,
    transform: "translate(150.047 81.601) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2278",
    "data-name": "Path 2278",
    d: "M2037.8,1069.386v-1.021h0v-.009a2.025,2.025,0,0,0-1.5-1.847l-3.221,4.959v3.319h1.611C2035.568,1073.246,2036.809,1071.092,2037.8,1069.386Z",
    transform: "translate(-1887.983 -990.402)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    d: "M2187.679,1174.914a1.674,1.674,0,1,1-1.675-1.674A1.675,1.675,0,0,1,2187.679,1174.914Z",
    transform: "translate(-2028.449 -1089.515)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    d: "M2174.171,1060.992a2.864,2.864,0,0,0-5.6,0V1061h0v6.994h5.6V1061h0Z",
    transform: "translate(-2013.814 -983.177)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "M2179.417,1066.6a2.4,2.4,0,0,0-4.727,0v.009h0v6.423h4.727v-6.423h0Z",
    transform: "translate(-2019.496 -988.646)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_610",
    "data-name": "Rectangle 610",
    width: 0.209,
    height: 9.139,
    transform: "translate(157.446 75.611)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_611",
    "data-name": "Rectangle 611",
    width: 6.901,
    height: 0.582,
    transform: "translate(154.13 84.818)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_612",
    "data-name": "Rectangle 612",
    width: 0.209,
    height: 5.207,
    transform: "translate(160.154 78.902) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_613",
    "data-name": "Rectangle 613",
    width: 0.209,
    height: 5.207,
    transform: "translate(160.154 81.601) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    d: "M2179.417,1069.386v-1.021h0v-.009a2.025,2.025,0,0,0-1.5-1.847l-3.222,4.959v3.319h1.611C2177.189,1073.246,2178.43,1071.092,2179.417,1069.386Z",
    transform: "translate(-2019.497 -990.402)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    d: "M1904.428,1409.554a1.674,1.674,0,1,1-1.674-1.674A1.674,1.674,0,0,1,1904.428,1409.554Z",
    transform: "translate(-1765.413 -1307.41)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2284",
    "data-name": "Path 2284",
    d: "M1890.921,1295.632a2.864,2.864,0,0,0-5.6,0v.009h0v6.994h5.6v-6.994h0Z",
    transform: "translate(-1750.777 -1201.072)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    d: "M1896.164,1301.212a2.4,2.4,0,0,0-4.727,0,.025.025,0,0,0,0,.009h0v6.423h4.727v-6.423h0Z",
    transform: "translate(-1756.457 -1206.514)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_614",
    "data-name": "Rectangle 614",
    width: 0.209,
    height: 9.139,
    transform: "translate(137.232 92.356)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_615",
    "data-name": "Rectangle 615",
    width: 6.901,
    height: 0.582,
    transform: "translate(133.916 101.562)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_616",
    "data-name": "Rectangle 616",
    width: 0.209,
    height: 5.207,
    transform: "translate(139.941 95.646) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_617",
    "data-name": "Rectangle 617",
    width: 0.209,
    height: 5.207,
    transform: "translate(139.941 98.345) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2286",
    "data-name": "Path 2286",
    d: "M1896.167,1304.026v-1.02h0V1303a2.025,2.025,0,0,0-1.5-1.847l-3.222,4.96v3.319h1.61C1893.939,1307.886,1895.18,1305.731,1896.167,1304.026Z",
    transform: "translate(-1756.461 -1208.297)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2287",
    "data-name": "Path 2287",
    d: "M2046.04,1409.554a1.675,1.675,0,1,1-1.675-1.674A1.675,1.675,0,0,1,2046.04,1409.554Z",
    transform: "translate(-1896.917 -1307.41)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2288",
    "data-name": "Path 2288",
    d: "M2032.541,1295.632a2.865,2.865,0,0,0-5.6,0v.009h0v6.994h5.6v-6.994h0Z",
    transform: "translate(-1882.291 -1201.072)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2289",
    "data-name": "Path 2289",
    d: "M2037.8,1301.212a2.4,2.4,0,0,0-4.726,0v.009h0v6.423h4.726v-6.423h0Z",
    transform: "translate(-1887.983 -1206.514)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_618",
    "data-name": "Rectangle 618",
    width: 0.209,
    height: 9.139,
    transform: "translate(147.34 92.356)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_619",
    "data-name": "Rectangle 619",
    width: 6.901,
    height: 0.582,
    transform: "translate(144.023 101.562)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_620",
    "data-name": "Rectangle 620",
    width: 0.209,
    height: 5.207,
    transform: "translate(150.048 95.646) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_621",
    "data-name": "Rectangle 621",
    width: 0.209,
    height: 5.207,
    transform: "translate(150.048 98.345) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2290",
    "data-name": "Path 2290",
    d: "M2037.8,1304v-1.02h0v-.011a2.025,2.025,0,0,0-1.5-1.847l-3.221,4.96v3.319h1.611C2035.568,1307.858,2036.809,1305.7,2037.8,1304Z",
    transform: "translate(-1887.983 -1208.269)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2291",
    "data-name": "Path 2291",
    d: "M2187.679,1409.554a1.674,1.674,0,1,1-1.675-1.674A1.675,1.675,0,0,1,2187.679,1409.554Z",
    transform: "translate(-2028.449 -1307.41)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2292",
    "data-name": "Path 2292",
    d: "M2174.171,1295.632a2.864,2.864,0,0,0-5.6,0v.009h0v6.994h5.6v-6.994h0Z",
    transform: "translate(-2013.814 -1201.072)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    d: "M2179.417,1301.212a2.4,2.4,0,0,0-4.727,0v.009h0v6.423h4.727v-6.423h0Z",
    transform: "translate(-2019.496 -1206.514)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_622",
    "data-name": "Rectangle 622",
    width: 0.209,
    height: 9.139,
    transform: "translate(157.446 92.356)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_623",
    "data-name": "Rectangle 623",
    width: 6.901,
    height: 0.582,
    transform: "translate(154.13 101.562)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_624",
    "data-name": "Rectangle 624",
    width: 0.209,
    height: 5.207,
    transform: "translate(160.154 95.646) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_625",
    "data-name": "Rectangle 625",
    width: 0.209,
    height: 5.207,
    transform: "translate(160.154 98.345) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    d: "M2179.417,1304.026v-1.02h0V1303a2.025,2.025,0,0,0-1.5-1.847l-3.222,4.96v3.319h1.611C2177.189,1307.886,2178.43,1305.731,2179.417,1304.026Z",
    transform: "translate(-2019.497 -1208.297)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    d: "M1416.122,1367.557a4.5,4.5,0,0,0-8.992,0v.018h0v13.381h8.992v-13.381h0Z",
    transform: "translate(-1306.712 -1265.947)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M1424.52,1378.245a3.8,3.8,0,1,0-7.59,0v.016h0v12.292h7.59v-12.292h0Z",
    transform: "translate(-1315.813 -1276.366)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_626",
    "data-name": "Rectangle 626",
    width: 0.442,
    height: 17.095,
    transform: "translate(104.709 97.684)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M1416.893,1390.615h.861l5.247-15.3a3.782,3.782,0,0,0-2.315-.785q-.092,0-.184,0l-3.611,10.53Z",
    transform: "translate(-1315.776 -1276.44)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M1453.547,1403.326h0v-.016a3.766,3.766,0,0,0-.5-1.88l-4.857,14.162h2l3.354-9.777Z",
    transform: "translate(-1344.842 -1301.421)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_627",
    "data-name": "Rectangle 627",
    width: 40.771,
    height: 22.553,
    transform: "translate(84.324 43.711)",
    fill: "#00b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M1442.362,815.031a2.141,2.141,0,1,1-2.141-2.141A2.141,2.141,0,0,1,1442.362,815.031Z",
    transform: "translate(-1335.454 -754.881)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    d: "M1425.1,669.381c0-1.6-1.6-2.891-3.581-2.891s-3.58,1.295-3.58,2.891v.012h0v8.942h7.161v-8.94h0Z",
    transform: "translate(-1316.751 -618.928)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M1431.813,676.564a3.069,3.069,0,0,0-6.043,0v.011h0v8.213h6.043v-8.213h0A.053.053,0,0,1,1431.813,676.564Z",
    transform: "translate(-1324.022 -625.93)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_628",
    "data-name": "Rectangle 628",
    width: 0.267,
    height: 11.684,
    transform: "translate(104.628 47.637)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_629",
    "data-name": "Rectangle 629",
    width: 8.822,
    height: 0.744,
    transform: "translate(100.388 59.407)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_630",
    "data-name": "Rectangle 630",
    width: 0.267,
    height: 6.657,
    transform: "translate(108.09 51.844) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_631",
    "data-name": "Rectangle 631",
    width: 0.267,
    height: 6.657,
    transform: "translate(108.09 55.294) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M1600.372,815.031a2.141,2.141,0,1,1-2.141-2.141A2.141,2.141,0,0,1,1600.372,815.031Z",
    transform: "translate(-1482.188 -754.881)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "M1583.157,669.381c0-1.6-1.6-2.891-3.58-2.891s-3.577,1.3-3.577,2.891v.012h0v8.942h7.161v-8.94h0Z",
    transform: "translate(-1463.531 -618.928)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M1589.823,676.564a3.068,3.068,0,0,0-6.043,0v.011h0v8.213h6.043v-8.213h0Z",
    transform: "translate(-1470.756 -625.93)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_632",
    "data-name": "Rectangle 632",
    width: 0.267,
    height: 11.684,
    transform: "translate(115.904 47.637)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_633",
    "data-name": "Rectangle 633",
    width: 8.823,
    height: 0.744,
    transform: "translate(111.664 59.407)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_634",
    "data-name": "Rectangle 634",
    width: 0.267,
    height: 6.657,
    transform: "translate(119.366 51.844) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_635",
    "data-name": "Rectangle 635",
    width: 0.267,
    height: 6.657,
    transform: "translate(119.367 55.294) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M1200.6,592.17H1175.36v1.514h42.1V592.17Z",
    transform: "translate(-1091.482 -549.912)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_636",
    "data-name": "Rectangle 636",
    width: 5.137,
    height: 46.786,
    transform: "translate(78.465 67.829)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_637",
    "data-name": "Rectangle 637",
    width: 7.464,
    height: 2.341,
    transform: "translate(77.301 67.829)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_638",
    "data-name": "Rectangle 638",
    width: 6.501,
    height: 1.495,
    transform: "translate(77.783 113.12)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_639",
    "data-name": "Rectangle 639",
    width: 5.778,
    height: 0.952,
    transform: "translate(78.144 77.574)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_640",
    "data-name": "Rectangle 640",
    width: 5.778,
    height: 0.952,
    transform: "translate(78.144 81.419)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_641",
    "data-name": "Rectangle 641",
    width: 5.778,
    height: 0.952,
    transform: "translate(78.144 101.443)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_642",
    "data-name": "Rectangle 642",
    width: 5.778,
    height: 0.952,
    transform: "translate(78.144 105.288)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_643",
    "data-name": "Rectangle 643",
    width: 5.137,
    height: 46.786,
    transform: "translate(126.239 67.933)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_644",
    "data-name": "Rectangle 644",
    width: 7.464,
    height: 2.341,
    transform: "translate(125.075 67.933)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_645",
    "data-name": "Rectangle 645",
    width: 6.501,
    height: 1.495,
    transform: "translate(125.557 113.225)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_646",
    "data-name": "Rectangle 646",
    width: 5.778,
    height: 0.952,
    transform: "translate(125.918 77.678)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_647",
    "data-name": "Rectangle 647",
    width: 5.778,
    height: 0.952,
    transform: "translate(125.918 81.524)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_648",
    "data-name": "Rectangle 648",
    width: 5.778,
    height: 0.952,
    transform: "translate(125.918 101.548)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_649",
    "data-name": "Rectangle 649",
    width: 5.778,
    height: 0.952,
    transform: "translate(125.918 105.393)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M1284.352,815.031a2.141,2.141,0,1,1-2.141-2.141A2.141,2.141,0,0,1,1284.352,815.031Z",
    transform: "translate(-1188.72 -754.881)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "M1267.091,669.381c0-1.6-1.6-2.891-3.58-2.891s-3.58,1.295-3.58,2.891v.012h0v8.942h7.161v-8.94h0A.083.083,0,0,1,1267.091,669.381Z",
    transform: "translate(-1170.017 -618.928)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M1273.8,676.564a3.068,3.068,0,0,0-6.042,0v.011h0v8.213h6.042v-8.213h0Z",
    transform: "translate(-1177.289 -625.93)",
    fill: "#3e6193"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_650",
    "data-name": "Rectangle 650",
    width: 0.267,
    height: 11.684,
    transform: "translate(93.352 47.637)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_651",
    "data-name": "Rectangle 651",
    width: 8.822,
    height: 0.744,
    transform: "translate(89.112 59.407)",
    fill: "#f2e3d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_652",
    "data-name": "Rectangle 652",
    width: 0.267,
    height: 6.657,
    transform: "translate(96.813 51.844) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_653",
    "data-name": "Rectangle 653",
    width: 0.267,
    height: 6.657,
    transform: "translate(96.814 55.294) rotate(90)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M1273.633,680.3V679h0v-.011a2.587,2.587,0,0,0-1.927-2.36l-4.116,6.338v4.24h2.059C1270.786,685.236,1272.371,682.484,1273.633,680.3Z",
    transform: "translate(-1177.13 -628.345)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M1432.259,680.3V679h0v-.011a2.587,2.587,0,0,0-1.922-2.36l-4.116,6.338v4.24h2.058C1429.416,685.236,1431,682.484,1432.259,680.3Z",
    transform: "translate(-1324.44 -628.345)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M1432.259,1072.814v-1.3h0v-.011a2.59,2.59,0,0,0-1.922-2.359l-4.116,6.337v4.241h2.058C1429.416,1077.746,1431,1074.993,1432.259,1072.814Z",
    transform: "translate(-1324.44 -992.844)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "M1590.783,680.3V679h0v-.011a2.587,2.587,0,0,0-1.927-2.36l-4.116,6.338v4.24h2.059C1587.937,685.236,1589.521,682.484,1590.783,680.3Z",
    transform: "translate(-1471.648 -628.345)",
    fill: "#fcf5eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2313",
    "data-name": "Path 2313",
    d: "M177.763,1685.257c2.8,0,23.122-3.969,25.916-3.756,6.791.517,13.579,2.283,20.316,1.368,6.114-.829,11.686-3.819,17.841-4.361a44.156,44.156,0,0,0,6.071-.544c1.952-.45,5.909-3.154,5.909-3.154l-206.545-.04a8.006,8.006,0,0,0,5.348,4.674c18.269,3.891,53.6.571,72.316,2.06,5.021.4,12.4,3.321,17.418,3.754C147.7,1685.718,175.015,1685.256,177.763,1685.257Z",
    transform: "translate(-43.897 -1555.254)",
    fill: "#f4b98c",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_654",
    "data-name": "Rectangle 654",
    width: 0.198,
    height: 2.949,
    transform: "translate(133.953 115.08)",
    fill: "#31535b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_655",
    "data-name": "Rectangle 655",
    width: 0.198,
    height: 2.949,
    transform: "translate(143.719 115.08)",
    fill: "#31535b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_656",
    "data-name": "Rectangle 656",
    width: 11.323,
    height: 0.587,
    rx: 0.293,
    transform: "translate(133.273 114.673)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_657",
    "data-name": "Rectangle 657",
    width: 11.323,
    height: 0.587,
    rx: 0.293,
    transform: "translate(133.273 115.506)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_658",
    "data-name": "Rectangle 658",
    width: 11.323,
    height: 0.587,
    rx: 0.293,
    transform: "translate(133.273 116.338)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2314",
    "data-name": "Path 2314",
    d: "M1867.167,1650.77h10.62a.407.407,0,0,1,.407.407v.046H1866.76v-.046A.407.407,0,0,1,1867.167,1650.77Z",
    transform: "translate(-1733.542 -1532.967)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_659",
    "data-name": "Rectangle 659",
    width: 11.657,
    height: 0.206,
    rx: 0.103,
    transform: "translate(133.095 118.196)",
    fill: "#31535b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2315",
    "data-name": "Path 2315",
    d: "M1958.733,1604.638c.156-.085,1.46-.8,1.509-.848s.65-1.015.65-1.015l-.531-.125-.527.912c-.044.033-.874.636-.874.636s-.149.114-.242.176h-.076a.662.662,0,0,1-.127-.019.727.727,0,0,0-.163-.018l-.113.02c-.032.007-.072.013-.087.019a.18.18,0,0,1-.051,0,.028.028,0,0,0-.024.046.115.115,0,0,0,.071.026c.061.009.155-.013.154,0s-.143.1-.156.109a1.894,1.894,0,0,0-.2.143c-.024.03-.01.051.013.048s.25-.129.25-.129.03-.016.026,0-.214.133-.242.156-.036.052,0,.059a1.238,1.238,0,0,0,.258-.129s.027-.017.03,0-.178.109-.19.126a.027.027,0,0,0,0,.03.026.026,0,0,0,.027.013,1.2,1.2,0,0,0,.23-.124s.018,0,.016.005-.151.1-.158.125a.02.02,0,0,0,0,.015.021.021,0,0,0,.011.01c.033.021.164-.089.239-.12S1958.728,1604.641,1958.733,1604.638Z",
    transform: "translate(-1818.209 -1488.281)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    d: "M1984.129,1597.29s-.121.041-.28.428c-.148.363-.269.764-.269.764l.4.317s.147-.825.165-.856S1984.129,1597.29,1984.129,1597.29Z",
    transform: "translate(-1842.025 -1483.303)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2317",
    "data-name": "Path 2317",
    d: "M1975.144,1687.09l.019.318a1.665,1.665,0,0,1,.034.176c0,.137-.652-.117-.506-.178.013-.006.083-.047.087-.094.007-.071.023-.218.023-.218Z",
    transform: "translate(-1833.751 -1566.695)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2318",
    "data-name": "Path 2318",
    d: "M1967.951,1691.43s.153.042.231.053.182-.078.238-.054.058.263.058.263a5.364,5.364,0,0,1-1.052,0C1967.334,1691.661,1967.637,1691.527,1967.951,1691.43Z",
    transform: "translate(-1827.008 -1570.72)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2319",
    "data-name": "Path 2319",
    d: "M1959.634,1686.44l.019.318a1.666,1.666,0,0,1,.035.176c0,.137-.652-.117-.506-.178.013-.006.112-.023.116-.071.006-.071.019-.295.019-.295Z",
    transform: "translate(-1819.348 -1566.045)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2320",
    "data-name": "Path 2320",
    d: "M1952.439,1691.43s.153.042.231.053.182-.078.238-.054.059.263.059.263a5.359,5.359,0,0,1-1.052,0C1951.823,1691.661,1952.126,1691.527,1952.439,1691.43Z",
    transform: "translate(-1812.604 -1570.72)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2321",
    "data-name": "Path 2321",
    d: "M1963.033,1640.53l-1.559.006s-.7-.018-.816.226-.118,3.131-.118,3.131a2.409,2.409,0,0,0,.387,0l.465-1.611a1.322,1.322,0,0,0,.046-.484l-.041-.428.642.033s.729-.012.97-.254S1963.033,1640.53,1963.033,1640.53Z",
    transform: "translate(-1820.629 -1523.458)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2322",
    "data-name": "Path 2322",
    d: "M1977.1,1638.12l-1.677.1s-.721.059-.833.3a28.51,28.51,0,0,0,.037,3.129,3.219,3.219,0,0,0,.423,0c0-.019.2-1.188.3-1.634a1.567,1.567,0,0,0,.032-.428l-.025-.377a14.852,14.852,0,0,0,1.8-.112C1977.394,1638.859,1977.1,1638.12,1977.1,1638.12Z",
    transform: "translate(-1833.639 -1521.22)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    "data-name": "Path 2323",
    d: "M1987.546,1596.346a4.366,4.366,0,0,1,.677-.063,1.678,1.678,0,0,1,.364,0c.128.037.373.066.357.636-.011.407-.008,1.751-.006,2.433l-1.677.009C1987.421,1597.989,1987.322,1596.4,1987.546,1596.346Z",
    transform: "translate(-1845.443 -1482.359)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    "data-name": "Path 2324",
    d: "M1993.146,1589.4l.23.5s-.22.337-.407.335c-.157,0-.117-.232-.117-.232a1.443,1.443,0,0,0-.071-.439C1992.714,1589.424,1993.146,1589.4,1993.146,1589.4Z",
    transform: "translate(-1850.562 -1475.976)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2325",
    "data-name": "Path 2325",
    d: "M1993.129,1589.591a.989.989,0,0,1-.276.18.773.773,0,0,0-.053-.209c-.031-.064.045-.1.135-.128.121-.023.23-.034.23-.034l.044.1A.426.426,0,0,1,1993.129,1589.591Z",
    transform: "translate(-1850.58 -1475.976)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2326",
    "data-name": "Path 2326",
    d: "M1988.335,1576.485c.011-.006.229.612.1.821s-.428.332-.571.214a1.028,1.028,0,0,1-.077-1.044C1988.006,1576.243,1988.335,1576.485,1988.335,1576.485Z",
    transform: "translate(-1845.83 -1463.88)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2327",
    "data-name": "Path 2327",
    d: "M1987.289,1572.79a.715.715,0,0,1,.412.133.47.47,0,0,1,.389.2.526.526,0,0,1,0,.7.411.411,0,0,0-.114.334l-.045-.077a.453.453,0,0,1-.063-.189.39.39,0,0,1,0-.123c.024-.1-.124-.134-.177-.2-.041-.053-.071-.187-.137-.275l-.072-.063a.356.356,0,0,0-.265-.019C1987.105,1573.26,1987.027,1572.791,1987.289,1572.79Z",
    transform: "translate(-1845.306 -1460.552)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2328",
    "data-name": "Path 2328",
    d: "M1995.664,1583.145c.015.078.063.134.108.126s.071-.079.054-.156-.062-.134-.107-.125S1995.648,1583.067,1995.664,1583.145Z",
    transform: "translate(-1853.242 -1470.022)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    "data-name": "Path 2329",
    d: "M1989.318,1588.47l-.248.039a.109.109,0,0,0,.129.079C1989.333,1588.571,1989.318,1588.47,1989.318,1588.47Z",
    transform: "translate(-1847.123 -1475.113)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    d: "M1985.988,1626.341a1.115,1.115,0,0,0-.2-.118.269.269,0,0,0-.111-.015s-.084.008-.087.028a.043.043,0,0,0,.029.045.269.269,0,0,0,.064,0,.127.127,0,0,1,.045.072,1.1,1.1,0,0,1-.244.033h-.095a.679.679,0,0,1-.081-.011s-.086-.008-.087.019.071.045.15.061a1.371,1.371,0,0,1,.167.029c0,.02-.134.031-.134.031a.414.414,0,0,0-.094,0c-.039-.013-.107-.015-.106.019a.523.523,0,0,0,.092.036s.062.007.091.013a.966.966,0,0,0,.164,0c.035,0,.02.012.021.015a.678.678,0,0,1-.092.008.474.474,0,0,1-.089.007.623.623,0,0,0-.1,0c-.072.006-.054.049.013.055l.081.006c.108.007.208-.009.214,0a1.078,1.078,0,0,1-.179.034s-.1.039,0,.047a.837.837,0,0,0,.205-.009.745.745,0,0,0,.21-.04c.064-.027.154-.071.2-.09Z",
    transform: "translate(-1843.538 -1510.157)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2331",
    "data-name": "Path 2331",
    d: "M1997.455,1609.62l-.428.2s.143.377.148.423c0,0-.714.517-1.015.691l.049.278c.059-.032.106-.063.136-.078.058-.029,1-.468,1-.468s.368-.192.37-.268S1997.455,1609.62,1997.455,1609.62Z",
    transform: "translate(-1853.707 -1494.753)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2332",
    "data-name": "Path 2332",
    d: "M2002.832,1597.31a9.118,9.118,0,0,0-.491-1.051.336.336,0,0,0-.55-.023c-.143.176.5,1.273.5,1.273Z",
    transform: "translate(-1858.917 -1482.202)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2333",
    "data-name": "Path 2333",
    d: "M1920.588,1687.28l-.017.311c-.006.039-.031.136-.031.172,0,.134.579-.114.449-.174-.011-.006-.071-.046-.077-.092-.006-.071-.021-.214-.021-.214Z",
    transform: "translate(-1783.484 -1566.871)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2334",
    "data-name": "Path 2334",
    d: "M1920.672,1691.519a1.976,1.976,0,0,1-.206.051c-.071.011-.161-.076-.214-.053s-.052.258-.052.258a4.322,4.322,0,0,0,.934,0C1921.219,1691.746,1920.95,1691.614,1920.672,1691.519Z",
    transform: "translate(-1783.168 -1570.802)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    d: "M1934.378,1686.658l-.017.31c-.006.039-.031.136-.031.172,0,.134.58-.114.45-.173-.012-.006-.1-.023-.1-.071-.006-.071-.017-.285-.017-.285Z",
    transform: "translate(-1796.29 -1566.249)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    d: "M1934.452,1691.519a1.984,1.984,0,0,1-.206.051c-.072.011-.161-.076-.214-.053s-.052.258-.052.258a4.328,4.328,0,0,0,.935,0C1935,1691.746,1934.73,1691.614,1934.452,1691.519Z",
    transform: "translate(-1795.965 -1570.802)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    d: "M1907.791,1640.71l1.385.006s.626-.018.724.22.076,3.263.076,3.263a1.881,1.881,0,0,1-.351.034l-.376-1.811a1.4,1.4,0,0,1-.04-.472l.036-.422-.6-.051s-.621.071-.835-.164S1907.791,1640.71,1907.791,1640.71Z",
    transform: "translate(-1771.569 -1523.625)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    d: "M1895.473,1638.35l1.49.1s.642.057.739.3-.065,3.29-.065,3.29a2.582,2.582,0,0,1-.371.007c0-.018-.153-1.4-.238-1.833a1.658,1.658,0,0,1-.028-.421l.054-.488a9.848,9.848,0,0,1-1.451-.085C1895.39,1638.978,1895.473,1638.35,1895.473,1638.35Z",
    transform: "translate(-1760.191 -1521.433)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    "data-name": "Path 2339",
    d: "M1915.127,1610.576c.013-.039-.177-.071-.188-.109s.24-.044.25-.079c.017-.063-.275-.012-.27-.042s.3-.1.271-.149-.3.1-.31.072.263-.12.258-.2c0-.041-.446.2-.5.183s.055-.214.013-.242-.157.39-.186.4a6.347,6.347,0,0,1-.839.411c-.026-.071-.214-.447-.236-.514-.12.085-.258.1-.382.182a3.779,3.779,0,0,0,.463.8c.19.084.922-.523,1.07-.627s.23-.072.33-.1S1915.113,1610.614,1915.127,1610.576Z",
    transform: "translate(-1776.491 -1495.117)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    d: "M1887.307,1580.964a1.285,1.285,0,0,0-.118-.619.529.529,0,0,0-.471-.266c-.589,0-.664.772-1.038,1.071-.115.091-.243.166-.351.264a.951.951,0,0,0,.147,1.356.888.888,0,0,0,.97.173.983.983,0,0,0,.377-.4,5.483,5.483,0,0,0,.3-.75A2.766,2.766,0,0,0,1887.307,1580.964Z",
    transform: "translate(-1750.575 -1467.32)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2341",
    "data-name": "Path 2341",
    d: "M1905.923,1606.166a5.636,5.636,0,0,1-.552-.642c-.113-.194.077-.072.271-.119.071-.019.055-.448.194-.308a6.281,6.281,0,0,1,.515.628Z",
    transform: "translate(-1769.366 -1490.526)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2342",
    "data-name": "Path 2342",
    d: "M1896.21,1602.43s-.4-.077-.575.071.039,1.479.039,1.7a7.283,7.283,0,0,1-.124.843s.51,0,1.433.027c0,0,.007-1.409,0-1.57a4.257,4.257,0,0,0-.234-.876A2.252,2.252,0,0,0,1896.21,1602.43Z",
    transform: "translate(-1760.277 -1488.058)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2343",
    "data-name": "Path 2343",
    d: "M1902.844,1594.032l-.006.031a3.014,3.014,0,0,1-.133.5c-.056.106.193.442.432.4.072-.013-.061-.31-.054-.341l.046-.226.028-.143.046-.234Z",
    transform: "translate(-1766.914 -1480.266)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2344",
    "data-name": "Path 2344",
    d: "M1904.513,1594.1l.006-.031.357-.009s-.021.106-.046.234c-.009.045-.018.093-.028.143a.342.342,0,0,1-.172-.086.456.456,0,0,1-.129-.191Z",
    transform: "translate(-1768.589 -1480.304)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    d: "M1903.024,1582.828a.325.325,0,0,0-.275.117.629.629,0,0,0,.043.785c.263.228.524-.03.562-.3S1903.407,1582.818,1903.024,1582.828Z",
    transform: "translate(-1766.852 -1469.872)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2346",
    "data-name": "Path 2346",
    d: "M1911.994,1589.182c-.032.061-.085.094-.119.071s-.035-.083,0-.143.084-.094.118-.076S1912.025,1589.122,1911.994,1589.182Z",
    transform: "translate(-1775.414 -1475.633)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2347",
    "data-name": "Path 2347",
    d: "M1900.981,1582.153s-.226.4-.387.419-.183.231-.183.231.058-.49.218-.584A.6.6,0,0,1,1900.981,1582.153Z",
    transform: "translate(-1764.791 -1469.242)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    d: "M1901.373,1588.024c.013.072-.013.136-.059.143s-.094-.041-.106-.112.013-.136.059-.143S1901.36,1587.953,1901.373,1588.024Z",
    transform: "translate(-1765.528 -1474.594)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    "data-name": "Path 2349",
    d: "M1906.338,1593.2l-.248-.013a.108.108,0,0,0,.11.1C1906.333,1593.3,1906.338,1593.2,1906.338,1593.2Z",
    transform: "translate(-1770.065 -1479.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2350",
    "data-name": "Path 2350",
    d: "M1906.338,1593.2l-.248-.013a.108.108,0,0,0,.11.1C1906.333,1593.3,1906.338,1593.2,1906.338,1593.2Z",
    transform: "translate(-1770.065 -1479.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    d: "M1901.707,1613.226c.014-.039-.177-.071-.187-.109s.241-.044.25-.078c.016-.064-.275-.013-.27-.043s.3-.1.272-.148-.3.1-.311.071.263-.121.258-.2c0-.041-.445.205-.5.183s.054-.214.014-.242-.158.39-.186.4a6.256,6.256,0,0,1-.839.411c-.026-.071-.214-.447-.237-.514-.119.085-.258.1-.381.181a3.793,3.793,0,0,0,.462.8c.19.084.922-.524,1.07-.627s.23-.071.329-.1S1901.693,1613.265,1901.707,1613.226Z",
    transform: "translate(-1764.029 -1497.578)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    d: "M1894.881,1603.643a5.552,5.552,0,0,1-.3-.792c-.039-.221.151-.5.352-.482s.5,1,.5,1Z",
    transform: "translate(-1759.374 -1488.02)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_660",
    "data-name": "Rectangle 660",
    width: 0.221,
    height: 2.909,
    transform: "translate(133.564 118.401)",
    fill: "#31535b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_661",
    "data-name": "Rectangle 661",
    width: 0.221,
    height: 2.909,
    transform: "translate(144.18 118.401)",
    fill: "#31535b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_662",
    "data-name": "Rectangle 662",
    width: 0.198,
    height: 2.949,
    transform: "translate(148.776 115.08)",
    fill: "#31535b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_663",
    "data-name": "Rectangle 663",
    width: 0.198,
    height: 2.949,
    transform: "translate(158.542 115.08)",
    fill: "#31535b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_664",
    "data-name": "Rectangle 664",
    width: 11.323,
    height: 0.587,
    rx: 0.293,
    transform: "translate(148.096 114.673)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_665",
    "data-name": "Rectangle 665",
    width: 11.323,
    height: 0.587,
    rx: 0.293,
    transform: "translate(148.096 115.506)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_666",
    "data-name": "Rectangle 666",
    width: 11.323,
    height: 0.587,
    rx: 0.293,
    transform: "translate(148.096 116.338)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2353",
    "data-name": "Path 2353",
    d: "M2074.867,1650.77h10.622a.407.407,0,0,1,.406.407v.046H2074.46v-.046A.407.407,0,0,1,2074.867,1650.77Z",
    transform: "translate(-1926.42 -1532.967)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_667",
    "data-name": "Rectangle 667",
    width: 11.657,
    height: 0.206,
    rx: 0.103,
    transform: "translate(147.918 118.196)",
    fill: "#31535b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_668",
    "data-name": "Rectangle 668",
    width: 0.221,
    height: 2.909,
    transform: "translate(148.387 118.401)",
    fill: "#31535b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_669",
    "data-name": "Rectangle 669",
    width: 0.221,
    height: 2.909,
    transform: "translate(159.002 118.401)",
    fill: "#31535b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_670",
    "data-name": "Rectangle 670",
    width: 0.198,
    height: 2.949,
    transform: "translate(66.504 115.08)",
    fill: "#31535b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_671",
    "data-name": "Rectangle 671",
    width: 0.198,
    height: 2.949,
    transform: "translate(76.27 115.08)",
    fill: "#31535b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_672",
    "data-name": "Rectangle 672",
    width: 11.323,
    height: 0.587,
    rx: 0.293,
    transform: "translate(65.824 114.673)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_673",
    "data-name": "Rectangle 673",
    width: 11.323,
    height: 0.587,
    rx: 0.293,
    transform: "translate(65.824 115.506)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_674",
    "data-name": "Rectangle 674",
    width: 11.323,
    height: 0.587,
    rx: 0.293,
    transform: "translate(65.824 116.338)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    d: "M922.017,1650.77h10.62a.407.407,0,0,1,.407.407v.046H921.61v-.046A.407.407,0,0,1,922.017,1650.77Z",
    transform: "translate(-855.841 -1532.967)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_675",
    "data-name": "Rectangle 675",
    width: 11.657,
    height: 0.206,
    rx: 0.103,
    transform: "translate(65.646 118.196)",
    fill: "#31535b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_676",
    "data-name": "Rectangle 676",
    width: 0.221,
    height: 2.909,
    transform: "translate(66.115 118.401)",
    fill: "#31535b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_677",
    "data-name": "Rectangle 677",
    width: 0.221,
    height: 2.909,
    transform: "translate(76.73 118.401)",
    fill: "#31535b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_678",
    "data-name": "Rectangle 678",
    width: 0.198,
    height: 2.949,
    transform: "translate(50.819 115.08)",
    fill: "#31535b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_679",
    "data-name": "Rectangle 679",
    width: 0.198,
    height: 2.949,
    transform: "translate(60.584 115.08)",
    fill: "#31535b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680",
    "data-name": "Rectangle 680",
    width: 11.323,
    height: 0.587,
    rx: 0.293,
    transform: "translate(50.139 114.673)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_681",
    "data-name": "Rectangle 681",
    width: 11.323,
    height: 0.587,
    rx: 0.293,
    transform: "translate(50.139 115.506)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_682",
    "data-name": "Rectangle 682",
    width: 11.323,
    height: 0.587,
    rx: 0.293,
    transform: "translate(50.139 116.338)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    d: "M702.217,1650.77h10.62a.407.407,0,0,1,.407.407v.046H701.81v-.046A.407.407,0,0,1,702.217,1650.77Z",
    transform: "translate(-651.726 -1532.967)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_683",
    "data-name": "Rectangle 683",
    width: 11.657,
    height: 0.206,
    rx: 0.103,
    transform: "translate(49.96 118.196)",
    fill: "#31535b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_684",
    "data-name": "Rectangle 684",
    width: 0.221,
    height: 2.909,
    transform: "translate(50.43 118.401)",
    fill: "#31535b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_685",
    "data-name": "Rectangle 685",
    width: 0.221,
    height: 2.909,
    transform: "translate(61.045 118.401)",
    fill: "#31535b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M1299.464,1627.114c.027-.075.474-1.464.474-1.464l-.689.154-.313,1.079c-.027.054-.511,1.356-.679,1.781a.271.271,0,0,1-.2.164h0a.972.972,0,0,0-.2.071c-.029.019-.086.061-.12.086s-.071.054-.091.072a.209.209,0,0,1-.06.029.036.036,0,0,0-.029.036.037.037,0,0,0,.029.036.158.158,0,0,0,.1-.01c.071-.025.172-.1.175-.092s-.108.192-.119.214a2.572,2.572,0,0,0-.151.281c-.011.049.017.064.042.049s.22-.291.22-.291.025-.036.031-.013-.175.275-.194.318-.013.081.03.071a1.641,1.641,0,0,0,.228-.3s.023-.035.034-.021-.146.227-.151.253a.034.034,0,0,0,.013.037.034.034,0,0,0,.039,0,1.6,1.6,0,0,0,.2-.273s.017-.017.021,0-.118.2-.114.234a.024.024,0,0,0,.026.023c.05.006.143-.2.214-.274S1299.435,1627.2,1299.464,1627.114Z",
    transform: "translate(-1204.962 -1509.64)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M1362.381,1744.691s.147.143.151.2a2.4,2.4,0,0,1-.047.67c-.06.053-.237.09-.18.149a1.767,1.767,0,0,0,.592.024c.064,0,.143-.513.169-.588.037-.108.125-.357.093-.428a.639.639,0,0,0-.2-.183.983.983,0,0,1-.225-.241Z",
    transform: "translate(-1265.075 -1619.813)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2358",
    "data-name": "Path 2358",
    d: "M1334.938,1754.46l.132.373a2.578,2.578,0,0,1,.048.259c0,.2-.908-.172-.7-.26a.216.216,0,0,0,.083-.143.472.472,0,0,0-.077-.238Z",
    transform: "translate(-1239.158 -1629.248)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2359",
    "data-name": "Path 2359",
    d: "M1319,1657.49s-.066.667-.066.677c0,1.079-.214,3.187-.173,3.39.1.495,1.167,3.02,1.167,3.02l.577-.072-.752-3.022.277-1.213.392-2.405Z",
    transform: "translate(-1224.647 -1539.207)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    d: "M1326.3,1659.315l.11.632.3,2.6,1.128,2.543s-.158.37-.392.422l-1.8-2.612-1.115-3.341.039-.742Z",
    transform: "translate(-1230.007 -1540.443)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2361",
    "data-name": "Path 2361",
    d: "M1319,1612.531l.8.082s.036-.656.036-.969a2.717,2.717,0,0,0-.078-.856.7.7,0,0,0-.406.242A3.126,3.126,0,0,0,1319,1612.531Z",
    transform: "translate(-1224.872 -1495.837)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2362",
    "data-name": "Path 2362",
    d: "M1320.254,1611.224c-.016.116-.324,3.264-.324,3.264a2.262,2.262,0,0,0,2.261.125s-.048-2.212.009-2.512a4.716,4.716,0,0,0-.043-1.559,3.209,3.209,0,0,0-.562-.12,5.467,5.467,0,0,0-.986.012A1.564,1.564,0,0,0,1320.254,1611.224Z",
    transform: "translate(-1225.735 -1495.485)",
    fill: "#96d9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2363",
    "data-name": "Path 2363",
    d: "M1362.182,1747.59s-.339.956-.472,1c-.036.012-.2.043-.237.118a.346.346,0,0,0,0,.1h.707s.09-.421.125-.606a2.768,2.768,0,0,0,.166-.493C1362.451,1747.665,1362.182,1747.59,1362.182,1747.59Z",
    transform: "translate(-1264.311 -1622.877)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2364",
    "data-name": "Path 2364",
    d: "M1326.013,1760.1l-.1-.328a.914.914,0,0,1-.328.077,3.148,3.148,0,0,1-.322-.077c-.436.142-.794.214-.729.328Z",
    transform: "translate(-1230 -1634.188)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2365",
    "data-name": "Path 2365",
    d: "M1332.314,1601.046l.108.656s-.392.834-.627.764c-.2-.059-.076-.776-.076-.776a1.807,1.807,0,0,0,.071-.577C1331.755,1600.921,1332.314,1601.046,1332.314,1601.046Z",
    transform: "translate(-1236.649 -1486.754)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2366",
    "data-name": "Path 2366",
    d: "M1333.074,1601.114c-.032-.193.52-.067.52-.067l.009.057a.308.308,0,0,1-.06.094.74.74,0,0,1-.483.21A1.025,1.025,0,0,0,1333.074,1601.114Z",
    transform: "translate(-1237.928 -1486.755)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2367",
    "data-name": "Path 2367",
    d: "M1329.534,1585.333c.016-.005.125.775-.083.989s-.613.285-.758.116a1.194,1.194,0,0,1,.171-1.246C1329.187,1584.971,1329.534,1585.333,1329.534,1585.333Z",
    transform: "translate(-1233.777 -1472.002)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2368",
    "data-name": "Path 2368",
    d: "M1331.531,1581.686a.585.585,0,0,1,.428.326.616.616,0,0,1-.177.824.479.479,0,0,0-.223.363l-.037-.1a.542.542,0,0,1-.029-.238.438.438,0,0,1,.036-.143c.055-.113-.118-.188-.166-.282-.038-.071-.039-.238-.1-.357l-.072-.091a.459.459,0,0,0-.32-.087C1330.716,1581.936,1330.91,1581.195,1331.531,1581.686Z",
    transform: "translate(-1235.85 -1468.656)",
    fill: "#0e2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2369",
    "data-name": "Path 2369",
    d: "M1338.53,1594.13c0,.095.044.173.1.174s.1-.076.106-.171-.044-.173-.1-.174S1338.532,1594.034,1338.53,1594.13Z",
    transform: "translate(-1243.008 -1480.211)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2370",
    "data-name": "Path 2370",
    d: "M1335.83,1630.78l-.576.417.4.635a9.76,9.76,0,0,1-1.087.83s-.072.049-.168.1l-.071.043a.543.543,0,0,0-.156.012c-.056.019-.161.028-.186.045s-.119.143-.136.158a.145.145,0,0,0-.034.052c-.007.014-.123.095-.138.125s.024.1.051.114c0,0,0,.006,0,.021a.1.1,0,0,0,.013.071.062.062,0,0,0,.072.019s.013-.005.018,0a.189.189,0,0,0,.031.053c.02.019.049.022.089,0,0,0,.025.1.109.051l.114-.071a.518.518,0,0,0,.1-.041c.026-.019.193-.131.2-.143a.381.381,0,0,1,.035-.054,1,1,0,0,0,.091-.089,1.2,1.2,0,0,1,.1-.093l.168-.079h0c.808-.38,1.6-.729,1.558-1.023A5.473,5.473,0,0,0,1335.83,1630.78Z",
    transform: "translate(-1238.498 -1514.403)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2371",
    "data-name": "Path 2371",
    d: "M1347.662,1613.694l-.694.466a7.234,7.234,0,0,0-.6-.785c-.263-.26.1-1.054.265-1.009C1347.011,1612.465,1347.662,1613.694,1347.662,1613.694Z",
    transform: "translate(-1250.199 -1497.302)",
    fill: "#96d9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2372",
    "data-name": "Path 2372",
    d: "M1330,1598.86l.343.035a.151.151,0,0,1-.173.119C1329.979,1599,1330,1598.86,1330,1598.86Z",
    transform: "translate(-1235.082 -1484.761)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2373",
    "data-name": "Path 2373",
    d: "M1245.563,1747.67a4.155,4.155,0,0,0-.016.659.592.592,0,0,0,.024.08,1.038,1.038,0,0,1-.054.368l-1.133,0c-.062,0-.021-.039.03-.071a2.314,2.314,0,0,1,.41-.22c.016-.008.079-.046.1-.06a.767.767,0,0,0,.164-.143,1.449,1.449,0,0,0,.095-.528Z",
    transform: "translate(-1155.551 -1622.952)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    d: "M1243.734,1758.057a1.023,1.023,0,0,0,.642-.017c.031.091.089.4.054.4-.285,0-.524.054-1.339.042-.029,0-.026-.1-.006-.123A5.875,5.875,0,0,1,1243.734,1758.057Z",
    transform: "translate(-1154.36 -1632.582)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M1248.581,1652.475a3.705,3.705,0,0,1-.22,1.165c-.2.443-1.147,1.535-1.4,2.172a5.548,5.548,0,0,1,.277,1.264c-.018.452.009,1.647.009,1.647l-.509.016-.668-3.084,1.006-3.328.457-.808Z",
    transform: "translate(-1157.146 -1533.663)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    d: "M1308.6,1737.75a4.569,4.569,0,0,0,.451.538c.071.058.274.136.295.232a7.046,7.046,0,0,1-.907.946c-.049.044-.043-.016-.029-.081a2.444,2.444,0,0,1,.173-.463c.009-.019.031-.093.04-.119a.838.838,0,0,0,.031-.228c0-.129-.294-.488-.294-.488Z",
    transform: "translate(-1214.991 -1613.74)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2377",
    "data-name": "Path 2377",
    d: "M1307.96,1746.427a1.091,1.091,0,0,0,.5-.467c.089.051.326.159.305.19a4.5,4.5,0,0,1-.994,1.1c-.023.02-.121-.1-.121-.127C1307.656,1747.033,1307.955,1746.453,1307.96,1746.427Z",
    transform: "translate(-1214.332 -1621.364)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2378",
    "data-name": "Path 2378",
    d: "M1262.149,1658.54a3.689,3.689,0,0,1,.487,1.081c.091.477-.061,1.915.1,2.583a5.624,5.624,0,0,1,.951.877c.244.381.95,1.345.95,1.345l-.408.3-2.314-2.145-.937-2.863-.256-.958Z",
    transform: "translate(-1170.751 -1540.182)",
    fill: "#96d9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2379",
    "data-name": "Path 2379",
    d: "M1243.285,1625.24c.015-.08.25-1.56.25-1.56l-.674.264-.148,1.142c-.019.059-.3,1.461-.408,1.915a.28.28,0,0,1-.174.2h0a1.035,1.035,0,0,0-.192.1c-.026.024-.077.076-.108.107a.746.746,0,0,0-.081.085.251.251,0,0,1-.056.038.037.037,0,0,0,.009.072.164.164,0,0,0,.1-.026c.072-.037.158-.132.163-.121a2.172,2.172,0,0,1-.088.236,2.7,2.7,0,0,0-.109.309c0,.052.028.063.05.043s.177-.33.177-.33.021-.04.029-.018-.133.307-.143.357,0,.083.041.066a1.74,1.74,0,0,0,.185-.335s.017-.039.031-.026-.113.253-.113.281a.035.035,0,0,0,.02.035.036.036,0,0,0,.04-.006,1.693,1.693,0,0,0,.158-.309s.015-.019.02-.006-.087.225-.078.255a.024.024,0,0,0,.011.016.025.025,0,0,0,.019,0c.052,0,.113-.221.171-.312S1243.268,1625.328,1243.285,1625.24Z",
    transform: "translate(-1153.06 -1507.81)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2380",
    "data-name": "Path 2380",
    d: "M1260.3,1585.464a2,2,0,0,1,.181-.961.809.809,0,0,1,.723-.413c.9,0,1.019,1.2,1.6,1.661.176.143.373.256.539.409a1.48,1.48,0,0,1-.227,2.1,1.354,1.354,0,0,1-1.489.27,1.524,1.524,0,0,1-.58-.627,8.618,8.618,0,0,1-.455-1.163A4.347,4.347,0,0,1,1260.3,1585.464Z",
    transform: "translate(-1170.359 -1471.046)",
    fill: "#0e2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2381",
    "data-name": "Path 2381",
    d: "M1287.243,1630.171c0-.008-.3-1.284-.42-1.565s-.593-1.593-.593-1.593l.611-.134s.394,1.026.571,1.489a5.288,5.288,0,0,1,.111,1.559s.026.2.026.207h0a.507.507,0,0,0,.014.053.652.652,0,0,1,.029.1.371.371,0,0,0,.027.046c.007.012.023.176.027.2a.394.394,0,0,1-.008.086l.007.11c0,.081-.079.059-.079.059,0,.039-.011.059-.032.066a.166.166,0,0,1-.052,0l0,.014a.055.055,0,0,1-.043.046.08.08,0,0,1-.058-.019c-.009-.011-.015-.009-.015-.009a.1.1,0,0,1-.1-.007,1.342,1.342,0,0,1-.037-.148.129.129,0,0,1-.025-.045c0-.017-.058-.136-.062-.159s.031-.1.039-.151a.583.583,0,0,1,.066-.143.185.185,0,0,0,0-.066Z",
    transform: "translate(-1194.44 -1510.782)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2382",
    "data-name": "Path 2382",
    d: "M1255.392,1615.008c.285-.856.6-.821.6-.821l-.244,1.8c-.174-.048-.4-.153-.576-.2A7.674,7.674,0,0,1,1255.392,1615.008Z",
    transform: "translate(-1165.597 -1498.995)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2383",
    "data-name": "Path 2383",
    d: "M1261.643,1611.977s.52-.034.726.191-.456,2-.494,2.29a4.133,4.133,0,0,0,.19,1.048s-1.222.246-1.57.014c0,0-.037-2.057,0-2.262a5.765,5.765,0,0,1,.428-1.117A2.87,2.87,0,0,1,1261.643,1611.977Z",
    transform: "translate(-1170.527 -1496.941)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2384",
    "data-name": "Path 2384",
    d: "M1268.324,1602.121l.008.042a3.885,3.885,0,0,0,.173.655c.071.139-.25.579-.56.525-.093-.016.078-.4.071-.446-.016-.079-.037-.186-.058-.3-.013-.062-.025-.125-.036-.185-.034-.168-.061-.306-.061-.306Z",
    transform: "translate(-1177.381 -1487.78)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    d: "M1268.313,1602.164l-.008-.042-.465-.011.061.306.035.184a.437.437,0,0,0,.223-.112.586.586,0,0,0,.168-.25C1268.321,1602.208,1268.317,1602.183,1268.313,1602.164Z",
    transform: "translate(-1177.363 -1487.78)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2386",
    "data-name": "Path 2386",
    d: "M1264.117,1587.4a.417.417,0,0,1,.357.153.832.832,0,0,1-.056,1.029c-.341.3-.679-.039-.729-.4S1263.617,1587.39,1264.117,1587.4Z",
    transform: "translate(-1173.485 -1474.121)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2387",
    "data-name": "Path 2387",
    d: "M1262.185,1595.759c.041.08.109.124.153.1s.046-.11,0-.189-.109-.124-.153-.1S1262.145,1595.679,1262.185,1595.759Z",
    transform: "translate(-1172.084 -1481.699)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2388",
    "data-name": "Path 2388",
    d: "M1269.63,1586.525s.293.525.5.549.237.3.237.3-.071-.642-.286-.766a.773.773,0,0,0-.451-.085Z",
    transform: "translate(-1179.025 -1473.302)",
    fill: "#0e2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2389",
    "data-name": "Path 2389",
    d: "M1267.3,1599.67l-.438.017a.192.192,0,0,0,.21.164C1267.307,1599.849,1267.3,1599.67,1267.3,1599.67Z",
    transform: "translate(-1176.453 -1485.514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2390",
    "data-name": "Path 2390",
    d: "M1278.706,1614.928a7.943,7.943,0,0,1-.8-1.106c-.122-.3.061-.746.345-.781s1,1.29,1,1.29Z",
    transform: "translate(-1186.678 -1497.93)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2391",
    "data-name": "Path 2391",
    d: "M2232.107,1580.915c-.008-.052.237-.051.258-.1s-.292-.1-.3-.15c-.007-.084.347.042.346,0s-.357-.185-.308-.243.357.191.374.15-.3-.206-.282-.3c.012-.051.515.35.584.333s-.024-.281.033-.308.129.49.161.514.749.477,1,.591c.047-.084.385-.524.428-.6.131.132.357.081.5.2a7.733,7.733,0,0,1-.708,1.066c-.256.066-1.218-.764-1.379-.928s-.273-.137-.391-.2S2232.116,1580.968,2232.107,1580.915Z",
    transform: "translate(-2072.781 -1467.496)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2392",
    "data-name": "Path 2392",
    d: "M2262.62,1572.045a5.607,5.607,0,0,1,.587-1.2.594.594,0,0,1,.856.027c.143.254-.789,1.427-.789,1.427Z",
    transform: "translate(-2101.152 -1458.589)",
    fill: "#96d9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    d: "M2275.156,1562.982c-.367-.008-.326-.719-.326-.719a.545.545,0,0,0-.08.011.545.545,0,0,1,.08-.011.308.308,0,0,0,.276-.259,1.03,1.03,0,0,0,.016-.29c-.028-.175.451-.061.451-.061l.063.415a.3.3,0,0,0,.228.243S2275.523,1562.99,2275.156,1562.982Z",
    transform: "translate(-2112.416 -1450.176)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2394",
    "data-name": "Path 2394",
    d: "M2304.1,1691.681s.132.129.135.177a2.156,2.156,0,0,1-.042.6c-.054.048-.214.081-.162.135a1.573,1.573,0,0,0,.532.021c.058,0,.129-.462.152-.53.033-.1.114-.319.083-.387a.567.567,0,0,0-.183-.166.928.928,0,0,1-.2-.214Z",
    transform: "translate(-2139.603 -1570.623)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2395",
    "data-name": "Path 2395",
    d: "M2279.445,1700.507l.118.336c.009.053.044.185.044.233,0,.181-.816-.155-.634-.235a.2.2,0,0,0,.071-.128.428.428,0,0,0-.071-.214Z",
    transform: "translate(-2116.313 -1579.148)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2396",
    "data-name": "Path 2396",
    d: "M2265.12,1613s-.143.584-.143.593c0,.973-.107,2.893-.071,3.076.089.447,1.05,2.724,1.05,2.724l.519-.062-.357-2.443.5-1.682-.213-1.869Z",
    transform: "translate(-2103.267 -1497.892)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2397",
    "data-name": "Path 2397",
    d: "M2272.423,1614.558l-.2,2.2.831,3.109s-.143.333-.353.38l-1.615-2.355-1-3.014.036-.67Z",
    transform: "translate(-2108.079 -1499.016)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2398",
    "data-name": "Path 2398",
    d: "M2303.916,1694.28s-.305.861-.424.9c-.032.011-.184.039-.214.106a.3.3,0,0,0,0,.088h.636s.08-.38.112-.547a2.493,2.493,0,0,0,.15-.445C2304.156,1694.35,2303.916,1694.28,2303.916,1694.28Z",
    transform: "translate(-2138.904 -1573.372)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2399",
    "data-name": "Path 2399",
    d: "M2271.421,1705.557l-.094-.3a.837.837,0,0,1-.295.071,2.347,2.347,0,0,1-.29-.071c-.392.13-.713.193-.654.3Z",
    transform: "translate(-2108.081 -1583.568)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2400",
    "data-name": "Path 2400",
    d: "M2279.843,1561.734c-.028-.175.451-.061.451-.061l.008.051a.286.286,0,0,1-.052.086.632.632,0,0,1-.419.19A.959.959,0,0,0,2279.843,1561.734Z",
    transform: "translate(-2117.134 -1450.195)",
    fill: "#f47458",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2401",
    "data-name": "Path 2401",
    d: "M2276.346,1547.394c.013-.005.125.777-.056.972a.557.557,0,0,1-.714.046,1.162,1.162,0,0,1,.187-1.146C2276.043,1547.065,2276.346,1547.394,2276.346,1547.394Z",
    transform: "translate(-2113.111 -1436.789)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2402",
    "data-name": "Path 2402",
    d: "M2277.568,1542.751a.787.787,0,0,1,.409.233c.1.012.232.066.37.3a.571.571,0,0,1-.153.747.447.447,0,0,0-.195.331l-.032-.091a.5.5,0,0,1-.025-.214.426.426,0,0,1,.032-.13c.047-.1-.1-.171-.143-.256-.032-.066-.033-.214-.084-.324l-.061-.083a.382.382,0,0,0-.278-.078C2277.271,1543.212,2277.291,1542.694,2277.568,1542.751Z",
    transform: "translate(-2114.808 -1432.653)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2403",
    "data-name": "Path 2403",
    d: "M2284.54,1555.375c0,.086.038.157.087.157s.092-.071.093-.155-.038-.156-.087-.158S2284.542,1555.288,2284.54,1555.375Z",
    transform: "translate(-2121.508 -1444.235)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2404",
    "data-name": "Path 2404",
    d: "M2277.1,1560.668l-.246-.018a.108.108,0,0,0,.107.106C2277.089,1560.769,2277.1,1560.668,2277.1,1560.668Z",
    transform: "translate(-2114.367 -1449.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2405",
    "data-name": "Path 2405",
    d: "M2264.755,1570.942a1.262,1.262,0,0,1,.192-.3.524.524,0,0,1,.1-.016s-.042.714.326.719.707-.669.707-.669c.094.021.2.045.261.063,0,0,.321.061.408.542s.249,2.287.262,2.661c.009.272-.407.51-.984.615a1.84,1.84,0,0,1-.536.055h-.165c-.643-.008-.869-.19-.948-.3l-.04-.019a.326.326,0,0,1,0-.044.054.054,0,0,1,0-.013A4.8,4.8,0,0,1,2264.755,1570.942Z",
    transform: "translate(-2102.631 -1458.546)",
    fill: "#327f6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2406",
    "data-name": "Path 2406",
    d: "M2292.52,1582.7s.785,1.108.973,1.366.7,1.291.714,1.332-.257.55-.186.564.127-.268.2-.238.346.693.386.658c.072-.065-.149-.412-.108-.436s.2.383.285.367-.187-.372-.166-.4.3.3.337.226c.021-.041-.253-.292-.206-.318s.285.133.307.084-.219-.107-.3-.235-.2-.181-.271-.421a6.706,6.706,0,0,0-.517-1.686c-.286-.427-.871-1.232-.871-1.232Z",
    transform: "translate(-2128.918 -1469.411)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2407",
    "data-name": "Path 2407",
    d: "M2290.377,1573.99l-.766.516a8.584,8.584,0,0,0-.664-.874c-.291-.285.105-1.168.293-1.118C2289.66,1572.625,2290.377,1573.99,2290.377,1573.99Z",
    transform: "translate(-2125.505 -1460.293)",
    fill: "#96d9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2408",
    "data-name": "Path 2408",
    d: "M1635.6,1619.268l.04.035a.05.05,0,0,0,.072,0l.714-.785a.047.047,0,0,0,.013-.037.049.049,0,0,0-.019-.035l-.04-.036a.049.049,0,0,0-.036-.015.05.05,0,0,0-.036.015l-.714.785a.05.05,0,0,0,.006.072Z",
    transform: "translate(-1518.857 -1502.903)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2409",
    "data-name": "Path 2409",
    d: "M1600.99,1621.5c.1-.078.833.247.823.357a11.13,11.13,0,0,0,.515,1.209l.906-.724h0c.009-.026.094-.308.1-.357s.157-.143.229-.132-.061.1-.072.12c-.024.044.067.062.067.062s.262-.143.268-.229.059-.263.116-.226c.029.019.029.143.02.206.016-.072.04-.143.063-.153.042-.014.063.041.056.067s-.076.315-.1.347-.442.374-.5.448c0,0-1.172,1.344-1.255,1.379s-.335-.433-.581-.74S1600.691,1621.739,1600.99,1621.5Z",
    transform: "translate(-1486.671 -1505.77)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2410",
    "data-name": "Path 2410",
    d: "M1557.642,1754.39s-.161.158-.164.214a2.636,2.636,0,0,0,.051.736c.065.058.258.1.2.164a1.9,1.9,0,0,1-.647.025c-.071,0-.158-.562-.186-.642-.04-.12-.138-.388-.1-.472a.686.686,0,0,1,.223-.2,1.09,1.09,0,0,0,.247-.264Z",
    transform: "translate(-1445.687 -1628.784)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2411",
    "data-name": "Path 2411",
    d: "M1589.626,1765.186s-.143.408-.143.41a2.807,2.807,0,0,0-.053.286c0,.22.994-.188.771-.286a.238.238,0,0,1-.09-.155.516.516,0,0,1,.083-.261Z",
    transform: "translate(-1476.003 -1639.212)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2412",
    "data-name": "Path 2412",
    d: "M1592.558,1658.7s.072.732.072.743c0,1.184.234,3.5.189,3.72-.108.543-1.277,3.313-1.277,3.313l-.632-.075.823-3.317-.3-1.335-.428-2.641Z",
    transform: "translate(-1477.378 -1540.331)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2413",
    "data-name": "Path 2413",
    d: "M1562.469,1660.694l-.12.694-.324,2.854-1.234,2.791s.173.406.428.463l1.966-2.865,1.22-3.667-.043-.814Z",
    transform: "translate(-1449.407 -1541.677)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2414",
    "data-name": "Path 2414",
    d: "M1605.615,1609.334l-.875.089s-.04-.72-.04-1.063a3.015,3.015,0,0,1,.086-.943.766.766,0,0,1,.443.266A3.5,3.5,0,0,1,1605.615,1609.334Z",
    transform: "translate(-1490.183 -1492.708)",
    fill: "#e25a44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2415",
    "data-name": "Path 2415",
    d: "M1583.25,1607.912c.018.127.357,3.582.357,3.582a2.468,2.468,0,0,1-2.474.138s.052-2.427-.01-2.756a5.245,5.245,0,0,1,.048-1.713,3.535,3.535,0,0,1,.615-.131,5.9,5.9,0,0,1,1.078.013A1.719,1.719,0,0,1,1583.25,1607.912Z",
    transform: "translate(-1468.248 -1492.333)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2416",
    "data-name": "Path 2416",
    d: "M1555.976,1757.58s.371,1.048.516,1.1c.038.013.224.048.258.13a.342.342,0,0,1,0,.107h-.773s-.1-.462-.137-.664a3.168,3.168,0,0,1-.182-.541A1.3,1.3,0,0,1,1555.976,1757.58Z",
    transform: "translate(-1444.64 -1632.155)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2417",
    "data-name": "Path 2417",
    d: "M1588.6,1771.357l.113-.357a.983.983,0,0,0,.357.084c.118-.017.353-.084.353-.084.477.157.868.233.8.357H1588.6Z",
    transform: "translate(-1475.232 -1644.617)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2418",
    "data-name": "Path 2418",
    d: "M1617.878,1643.2a.188.188,0,0,0,.024-.018,1.276,1.276,0,0,1,.083-.777l-.05-.106c-.123.1-.18.348-.158.759a.769.769,0,0,0,.016.085C1617.828,1643.184,1617.859,1643.206,1617.878,1643.2Z",
    transform: "translate(-1502.322 -1525.101)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2419",
    "data-name": "Path 2419",
    d: "M1558.83,1622.058a.068.068,0,0,1,0-.022c.023-.239.222-2.248.255-2.334s.918-1.352.918-1.352l.436.6-.856,1.142c-.019.072-.327,1.427-.327,1.427s-.063.247-.091.4c.013.036.026.072.037.1a.89.89,0,0,0,.091.148,1.013,1.013,0,0,1,.109.193c.009.035.026.108.035.151s.021.095.024.119a.23.23,0,0,0,.028.063.038.038,0,0,1,0,.043.038.038,0,0,1-.042.012c-.031-.01-.055-.051-.072-.075a1.9,1.9,0,0,1-.071-.194q-.033.124-.053.251a2.989,2.989,0,0,1-.072.327c-.025.046-.058.038-.067.009s.028-.382.028-.382,0-.046-.016-.031-.052.338-.066.385-.045.071-.071.034a1.776,1.776,0,0,1,.023-.39s.006-.043-.012-.039-.041.281-.055.3a.036.036,0,0,1-.071-.007,1.717,1.717,0,0,1,.033-.353s0-.024-.014-.016-.048.242-.072.264a.025.025,0,0,1-.036,0c-.043-.029.024-.252.023-.362a2.685,2.685,0,0,0,.035-.367A.256.256,0,0,1,1558.83,1622.058Z",
    transform: "translate(-1447.525 -1502.861)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2420",
    "data-name": "Path 2420",
    d: "M1566.4,1610.606l.759.511a8.431,8.431,0,0,1,.656-.866c.285-.285-.1-1.157-.29-1.108C1567.111,1609.255,1566.4,1610.606,1566.4,1610.606Z",
    transform: "translate(-1454.616 -1494.31)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2421",
    "data-name": "Path 2421",
    d: "M1590.264,1596.246l-.114.75s.415.893.661.816c.208-.065.08-.856.08-.856a2.209,2.209,0,0,1-.079-.637C1590.846,1596.109,1590.264,1596.246,1590.264,1596.246Z",
    transform: "translate(-1476.672 -1482.293)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    d: "M1592.168,1596.315c.034-.214-.549-.072-.549-.072l-.01.062a.341.341,0,0,0,.064.1.765.765,0,0,0,.51.232A1.175,1.175,0,0,1,1592.168,1596.315Z",
    transform: "translate(-1478.027 -1482.288)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    d: "M1589.813,1578.892c-.016-.006-.132.856.087,1.092s.646.314.8.128a1.368,1.368,0,0,0-.18-1.375C1590.18,1578.493,1589.813,1578.892,1589.813,1578.892Z",
    transform: "translate(-1476.317 -1466.001)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    "data-name": "Path 2424",
    d: "M1584.907,1573.241a.944.944,0,0,0-.5.285.614.614,0,0,0-.45.357.7.7,0,0,0,.187.91.543.543,0,0,1,.237.4l.038-.111a.622.622,0,0,0,.031-.262.519.519,0,0,0-.039-.158c-.058-.124.124-.207.176-.311.039-.08.041-.262.1-.394l.071-.1a.471.471,0,0,1,.338-.1C1585.264,1573.8,1585.245,1573.171,1584.907,1573.241Z",
    transform: "translate(-1470.833 -1460.965)",
    fill: "#184655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    d: "M1591.008,1588.6c0,.1-.046.191-.106.192s-.11-.083-.113-.188.046-.19.106-.192S1591.007,1588.493,1591.008,1588.6Z",
    transform: "translate(-1477.265 -1475.057)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    "data-name": "Path 2426",
    d: "M1598.85,1594.227l.33-.017a.143.143,0,0,1-.143.138C1598.861,1594.363,1598.85,1594.227,1598.85,1594.227Z",
    transform: "translate(-1484.751 -1480.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2427",
    "data-name": "Path 2427",
    d: "M1718,1619.294s.694,1.526.842,1.809a11.59,11.59,0,0,1,.434,1.2c.012.043-.35.532-.282.557s.166-.246.238-.2.243.74.285.714c.083-.054-.088-.428-.044-.449s.143.41.228.407-.132-.4-.106-.428.252.344.3.275c.028-.038-.209-.327-.158-.347s.265.176.293.13-.2-.143-.263-.278a1.152,1.152,0,0,1-.208-.458,5.732,5.732,0,0,0-.268-1.6l-.713-1.5Z",
    transform: "translate(-1595.398 -1503.575)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2428",
    "data-name": "Path 2428",
    d: "M1670.675,1577.312a2.281,2.281,0,0,0-.207-1.1.925.925,0,0,0-.827-.473c-1.033,0-1.165,1.371-1.823,1.9-.2.161-.428.293-.617.468a1.693,1.693,0,0,0,.259,2.4,1.546,1.546,0,0,0,1.7.308,1.736,1.736,0,0,0,.663-.714,9.794,9.794,0,0,0,.521-1.33A5.007,5.007,0,0,0,1670.675,1577.312Z",
    transform: "translate(-1547.855 -1463.291)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2429",
    "data-name": "Path 2429",
    d: "M1666.934,1574.079c.048-.034.168.214.227.209s-.04-.344,0-.371c.081-.049.131.368.168.348s.009-.452.091-.428-.015.452.036.449.056-.407.162-.428c.056-.013-.1.689-.045.75s.27-.163.325-.119-.428.373-.434.417-.108.987-.095,1.3c.108.006.713.126.817.13-.066.2.1.4.043.6a8.569,8.569,0,0,1-1.419-.181c-.193-.223.162-1.6.243-1.841s0-.342.006-.49S1666.887,1574.114,1666.934,1574.079Z",
    transform: "translate(-1547.808 -1461.523)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2430",
    "data-name": "Path 2430",
    d: "M1690.609,1667.128a2.49,2.49,0,0,1,.428-.238c.018-.009.083-.05.106-.064a.836.836,0,0,0,.171-.151.87.87,0,0,0,.084-.371c-.029-.314-.483-5.338-.578-5.882a5.168,5.168,0,0,1,.052-1.417l.35-.133.665,2.306-.053,1.755a4.635,4.635,0,0,1,.177.809c.019.3-.226,2.756-.226,2.756h0a1.232,1.232,0,0,0,.013.214c.018.092.118.281.071.367a.228.228,0,0,1-.1.108l-1.2.019C1690.513,1667.208,1690.557,1667.166,1690.609,1667.128Z",
    transform: "translate(-1569.902 -1540.489)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2431",
    "data-name": "Path 2431",
    d: "M1697.564,1655.674a3.94,3.94,0,0,1,.514,1.142c.1.515-.071,2.111.118,2.791a9.644,9.644,0,0,1,.552,1.41c.059.475.265,1.847.265,1.847h0a1.245,1.245,0,0,0,.143.4,1.176,1.176,0,0,1,.156.206.612.612,0,0,1-.021.472c-.028.06,0,.06-.061.079a.384.384,0,0,1-.461-.214,1.1,1.1,0,0,1-.091-.4,1.845,1.845,0,0,0-.065-.421h0l-1.327-3.255-.96-2.81-.246-1.447Z",
    transform: "translate(-1575.042 -1537.341)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2432",
    "data-name": "Path 2432",
    d: "M1733.28,1767.762a.589.589,0,0,0,.577-.242.644.644,0,0,1,.055.473c-.047.1-.186.1-.294.1a.285.285,0,0,1-.261-.16.915.915,0,0,1-.077-.176Z",
    transform: "translate(-1609.587 -1641.385)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2433",
    "data-name": "Path 2433",
    d: "M1690.072,1769.987a1.079,1.079,0,0,0,.681-.027.55.55,0,0,1,.055.286c-.029.085-.071.1-.107.1-.285.008-1.058.018-1.278.021a.036.036,0,0,1-.033-.021.036.036,0,0,1,.006-.039A5.611,5.611,0,0,1,1690.072,1769.987Z",
    transform: "translate(-1568.825 -1643.651)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    "data-name": "Path 2434",
    d: "M1694.988,1659.006l-.071,0h-.007l-.071,0h-.156a5,5,0,0,1-.856-.032c-.115-1.147-.158-2.192-.2-2.427a4.71,4.71,0,0,1,.09-1.447l-.016-.214.049-.134,1.541.194a3.948,3.948,0,0,1,.534,1.142c.106.516-.076,2.111.123,2.791A6.051,6.051,0,0,1,1694.988,1659.006Z",
    transform: "translate(-1572.736 -1536.672)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    "data-name": "Path 2435",
    d: "M1683.67,1606.844a6.307,6.307,0,0,1,1.5-.007.668.668,0,0,1,.4.874c-.182.273-1.82-.084-1.82-.084Z",
    transform: "translate(-1563.518 -1492.124)",
    fill: "#eab054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    "data-name": "Path 2436",
    d: "M1695.247,1606.037s.571-.035.8.2-.5,2.132-.542,2.437a4.216,4.216,0,0,0,.21,1.115s-1.342.262-1.725.016c0,0-.071-2.212-.029-2.426a6.2,6.2,0,0,1,.495-1.168A3.277,3.277,0,0,1,1695.247,1606.037Z",
    transform: "translate(-1573.058 -1491.424)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    "data-name": "Path 2437",
    d: "M1702.891,1595.512l.008.044a4.126,4.126,0,0,0,.19.7c.08.147-.274.616-.615.559-.1-.017.086-.428.076-.474-.017-.084-.04-.2-.064-.316l-.04-.2-.066-.326Z",
    transform: "translate(-1580.893 -1481.641)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2438",
    "data-name": "Path 2438",
    d: "M1702.9,1595.556l-.008-.044-.511-.012.066.326.04.2a.48.48,0,0,0,.243-.119.615.615,0,0,0,.185-.267C1702.908,1595.607,1702.9,1595.577,1702.9,1595.556Z",
    transform: "translate(-1580.893 -1481.641)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2439",
    "data-name": "Path 2439",
    d: "M1698.262,1579.852a.468.468,0,0,1,.392.163.865.865,0,0,1-.061,1.095c-.375.319-.745-.042-.8-.428S1697.716,1579.839,1698.262,1579.852Z",
    transform: "translate(-1576.608 -1467.109)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2440",
    "data-name": "Path 2440",
    d: "M1696.188,1588.741c.044.084.12.131.168.1s.05-.117.006-.2-.12-.131-.167-.1S1696.146,1588.656,1696.188,1588.741Z",
    transform: "translate(-1575.114 -1475.171)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2441",
    "data-name": "Path 2441",
    d: "M1704.35,1578.921s.321.557.551.584.26.322.26.322-.082-.683-.31-.814a.863.863,0,0,0-.5-.091Z",
    transform: "translate(-1582.722 -1466.239)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2442",
    "data-name": "Path 2442",
    d: "M1711.168,1587.086c-.019.1.019.19.084.2s.133-.056.151-.156-.019-.19-.083-.2S1711.187,1586.987,1711.168,1587.086Z",
    transform: "translate(-1589.049 -1473.681)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2443",
    "data-name": "Path 2443",
    d: "M1702.528,1592.74l-.328.047a.142.142,0,0,0,.17.107C1702.548,1592.874,1702.528,1592.74,1702.528,1592.74Z",
    transform: "translate(-1580.725 -1479.078)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2444",
    "data-name": "Path 2444",
    d: "M1713.756,1609.605a6.4,6.4,0,0,1-.7-1.319c-.061-.355.261-.793.587-.759s.882,1.648.882,1.648Z",
    transform: "translate(-1590.798 -1492.808)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2445",
    "data-name": "Path 2445",
    d: "M972.169,1633.72s-1.583.155-1.713.22a.825.825,0,0,0-.53.677c-.043.452,1.208-.009,1.279-.034s.976-.513.968-.535S972.169,1633.72,972.169,1633.72Z",
    transform: "translate(-900.708 -1517.133)",
    fill: "#00213d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2446",
    "data-name": "Path 2446",
    d: "M944.545,1633.72s1.582.155,1.713.22.7-.2.747.25-1.427.417-1.5.392-.976-.513-.967-.535S944.545,1633.72,944.545,1633.72Z",
    transform: "translate(-877.134 -1517.133)",
    fill: "#00213d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2447",
    "data-name": "Path 2447",
    d: "M975,1648.992a.072.072,0,0,1,.068-.072.166.166,0,0,0,.1-.026.445.445,0,0,1,.319-.056c.13.026.466-.034.571.052s.25.233.146.3a1.449,1.449,0,0,1-.6.121c-.076-.018-.4-.042-.535-.052a.067.067,0,0,1-.064-.056Z",
    transform: "translate(-905.421 -1531.165)",
    fill: "#001333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2448",
    "data-name": "Path 2448",
    d: "M970.4,1648.452l-.307-.172-.052.352.413.118s-.007-.235-.016-.248S970.4,1648.452,970.4,1648.452Z",
    transform: "translate(-900.815 -1530.654)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2449",
    "data-name": "Path 2449",
    d: "M935,1633.4s-.06-.3.095-.379a1,1,0,0,1,.785.071c.3.143,2.13,1.018,2.13,1.018a2.094,2.094,0,0,1-.194.423l-2.013-.582C935.428,1633.845,935.109,1633.845,935,1633.4Z",
    transform: "translate(-868.266 -1516.44)",
    fill: "#223c56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2450",
    "data-name": "Path 2450",
    d: "M948.215,1649.257a.071.071,0,0,0-.068-.071.17.17,0,0,1-.1-.022.449.449,0,0,0-.319-.056c-.129.026-.465-.035-.571.052s-.25.233-.147.3a1.465,1.465,0,0,0,.6.121c.076-.017.405-.042.536-.051a.066.066,0,0,0,.063-.056Z",
    transform: "translate(-879.393 -1531.415)",
    fill: "#001333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2451",
    "data-name": "Path 2451",
    d: "M963.566,1648.662l.307-.172.071.434-.435.037s.007-.235.016-.248S963.566,1648.662,963.566,1648.662Z",
    transform: "translate(-894.751 -1530.85)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2452",
    "data-name": "Path 2452",
    d: "M969.659,1633.4s.06-.3-.095-.379a1,1,0,0,0-.785.071c-.3.143-2.13,1.018-2.13,1.018a2.1,2.1,0,0,0,.194.423l2.013-.582C969.232,1633.845,969.552,1633.845,969.659,1633.4Z",
    transform: "translate(-897.667 -1516.44)",
    fill: "#264160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2453",
    "data-name": "Path 2453",
    d: "M952.541,1583.367a.69.69,0,0,0-.478-.749.714.714,0,0,0-.258-.489c-.286-.23-.785-.321-.944.025a.694.694,0,0,0-.3.761,1.245,1.245,0,0,0-.415,1.3c.023.281.22.387.482.482.063.022.883.281.87-.188a.563.563,0,0,0,.836.2A.784.784,0,0,0,952.541,1583.367Z",
    transform: "translate(-882.27 -1469.035)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2454",
    "data-name": "Path 2454",
    d: "M932.147,1601.155c0-.043.195-.027.214-.064s-.231-.1-.231-.143c0-.072.28.054.281.023s-.281-.173-.236-.214.278.178.295.143-.235-.186-.211-.261c.012-.041.4.315.454.306s0-.229.047-.248.062.432.087.453a8.157,8.157,0,0,0,.778.608c.044-.066.251-.278.291-.34.1.115.15.193.255.3a3,3,0,0,1-.488.6c-.214.039-.849-.791-.971-.928s-.214-.128-.305-.186S932.151,1601.2,932.147,1601.155Z",
    transform: "translate(-865.61 -1486.409)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    d: "M980.542,1598.387c0-.043-.195-.027-.214-.065s.231-.1.232-.143c0-.071-.28.055-.281.023s.281-.173.236-.214-.278.177-.295.143.235-.186.21-.262c-.013-.04-.4.316-.454.306s0-.229-.046-.248-.062.428-.087.453a7.544,7.544,0,0,1-.778.608c-.043-.066-.251-.278-.291-.34-.1.115-.15.193-.255.3a3,3,0,0,0,.488.6c.214.039.849-.79.97-.928s.214-.128.3-.185S980.539,1598.43,980.542,1598.387Z",
    transform: "translate(-908.69 -1483.838)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    d: "M972.641,1602.775l-.343.41a4.87,4.87,0,0,0-.511-.377c-.208-.113-.13-.666-.018-.669C972.02,1602.134,972.641,1602.775,972.641,1602.775Z",
    transform: "translate(-902.316 -1487.807)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    d: "M954.58,1602.03a4.056,4.056,0,0,1,.746-.091.857.857,0,0,0,.093-.019.755.755,0,0,1,.489.419,1.878,1.878,0,0,1,.071,1.095,7.155,7.155,0,0,0,.089.969,1.238,1.238,0,0,1-1.37.091l.206-.906a3.082,3.082,0,0,0-.214-.746,1.517,1.517,0,0,0-.1.176c-.137,0-.479-.348-.479-.348A5.312,5.312,0,0,1,954.58,1602.03Z",
    transform: "translate(-886.021 -1487.603)",
    fill: "#96d9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    d: "M967.47,1594.924a2.377,2.377,0,0,1,.044.412c-.011.116.041.492.278.493s.045-.477.023-.592a4.637,4.637,0,0,1-.028-.468Z",
    transform: "translate(-898.428 -1480.963)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    d: "M967.8,1594.947c0-.1-.005-.177-.005-.177l-.318.154s.011.06.023.137A.27.27,0,0,0,967.8,1594.947Z",
    transform: "translate(-898.437 -1480.963)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    d: "M963.488,1584.991a.406.406,0,0,0-.168.224.554.554,0,0,0,.323.642c.316.093.453-.218.388-.463S963.824,1584.842,963.488,1584.991Z",
    transform: "translate(-894.562 -1471.846)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    d: "M972.259,1588.214c-.006.066-.041.116-.078.112s-.061-.06-.055-.125.041-.116.078-.113S972.266,1588.148,972.259,1588.214Z",
    transform: "translate(-902.751 -1474.758)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    d: "M962.663,1592.532c.037.057.037.125,0,.151s-.1,0-.135-.056-.037-.125,0-.152S962.626,1592.474,962.663,1592.532Z",
    transform: "translate(-893.813 -1478.822)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    d: "M962.565,1583.74s-.279.652-.5.623-.054-.39-.054-.4.133-.2.168-.2.249-.024.249-.024Z",
    transform: "translate(-893.303 -1470.72)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    d: "M179.787,1312.082a49.867,49.867,0,0,1-1.736-5.115,35,35,0,0,1-1.018-11.2c.006-.25-.392-.318-.428-.061a20.988,20.988,0,0,0-.152,2.68,33.853,33.853,0,0,0,.275,4.53,3.018,3.018,0,0,1-2.816-.861,7.183,7.183,0,0,1-2.091-4.773c-.022-.189-.029-.368-.183-.478a.107.107,0,0,0-.211.018c-.219.225-.113.678-.079.97.455,3.939,2.845,5.852,4.769,5.833a2.747,2.747,0,0,0,.7-.076q.208,1.413.535,2.8a40.8,40.8,0,0,0,1.641,5.154c2.194,5.768,2.894,8.715,3.517,10.385a.261.261,0,0,0,.5-.143C182.981,1321.626,181.269,1315.946,179.787,1312.082Z",
    transform: "translate(-159.07 -1203.093)",
    fill: "#0e2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    d: "M305.509,1301.13c-.021-.124-.093-.206-.121-.323a.161.161,0,0,0-.313,0c-.015.1-.068.156-.088.255a35.657,35.657,0,0,1-.328,4.86,12.13,12.13,0,0,1-.479,2.153,7.529,7.529,0,0,1-2,3.108,46.987,46.987,0,0,0-.317-4.814q-.173-1.436-.437-2.855-.129-.691-.279-1.378a5.274,5.274,0,0,0-.434-1.377.143.143,0,0,0-.271.077,5.741,5.741,0,0,0,.173,1.233c.089.414.171.826.248,1.242a46.724,46.724,0,0,1,.785,8.886,18.72,18.72,0,0,1-3.806-9.319q-.087-.77-.1-1.544-.009-.4-.016-.8c0-.137-.056-.552-.285-.428-.214.112-.193.361-.211.579-.019.238-.021.474-.018.714q.009.684.071,1.366a19.284,19.284,0,0,0,3.425,9.206,9.377,9.377,0,0,0,.932,1.2c-.08,5.266-.861,11.917-.874,12.45a1.98,1.98,0,0,0,.041.357c.036.239.349.183.413,0a11.554,11.554,0,0,0,.29-2.4c.322-3.426.682-11.275.681-11.593a7.472,7.472,0,0,0,2.426-3.338,10.041,10.041,0,0,0,.557-2.124A25.135,25.135,0,0,0,305.509,1301.13Z",
    transform: "translate(-276 -1207.305)",
    fill: "#0e2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2466",
    "data-name": "Path 2466",
    d: "M147.864,1135.637a10.37,10.37,0,0,0,.065-1.163c0-4.4-2.731-7.974-6.1-7.974s-6.1,3.568-6.1,7.974a10.549,10.549,0,0,0,.064,1.163Z",
    transform: "translate(-126.044 -1046.111)",
    fill: "#184655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    d: "M244.594,1059.368q.064-.8.065-1.641c0-6.209-2.731-11.246-6.1-11.246s-6.1,5.035-6.1,11.246q0,.835.064,1.641Z",
    transform: "translate(-215.871 -971.801)",
    fill: "#3c8f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    "data-name": "Path 2468",
    d: "M233.351,1155.947q-.08-.8-.081-1.641c0-6.208,3.462-11.245,7.732-11.245s7.734,5.036,7.734,11.247c0,.557-.029,1.1-.082,1.641Z",
    transform: "translate(-216.623 -1061.489)",
    fill: "#184655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2469",
    "data-name": "Path 2469",
    d: "M132.978,1143.08c-2.134,0-4.041,1.6-5.3,4.1a5.984,5.984,0,0,0-2.027-.357c-3.789,0-6.862,3.568-6.862,7.975a9.3,9.3,0,0,0,.071,1.162h20.905q.071-.8.071-1.641C139.839,1148.115,136.767,1143.08,132.978,1143.08Z",
    transform: "translate(-110.313 -1061.507)",
    fill: "#3c8f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2470",
    "data-name": "Path 2470",
    d: "M245.037,1557.808a4.016,4.016,0,0,1-.057-.678c0-2.569,2.407-4.65,5.376-4.65s5.376,2.082,5.376,4.65a4.093,4.093,0,0,1-.057.678Z",
    transform: "translate(-227.497 -1441.691)",
    fill: "#3c8f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2471",
    "data-name": "Path 2471",
    d: "M159.777,1513.344a8.079,8.079,0,0,1-.057-.956c0-3.622,2.407-6.558,5.377-6.558s5.376,2.937,5.376,6.558a7.935,7.935,0,0,1-.057.956Z",
    transform: "translate(-148.322 -1398.37)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2472",
    "data-name": "Path 2472",
    d: "M48.925,1598.108a4.033,4.033,0,0,0,.057-.678c0-2.569-2.407-4.65-5.376-4.65s-5.377,2.085-5.377,4.65a4.034,4.034,0,0,0,.057.678Z",
    transform: "translate(-35.502 -1479.115)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2473",
    "data-name": "Path 2473",
    d: "M132.229,1569.664a6.408,6.408,0,0,0,.071-.956,6.82,6.82,0,0,0-13.63,0,6.314,6.314,0,0,0,.071.956Z",
    transform: "translate(-110.201 -1450.671)",
    fill: "#3c8f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2474",
    "data-name": "Path 2474",
    d: "M156.647,1562.15a5.856,5.856,0,0,1,4.671,2.392,7.755,7.755,0,0,1,1.784-.206c3.34,0,6.047,2.082,6.047,4.65a3.692,3.692,0,0,1-.064.678H150.664a7.156,7.156,0,0,1-.064-.956A6.318,6.318,0,0,1,156.647,1562.15Z",
    transform: "translate(-139.853 -1450.671)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_686",
    "data-name": "Rectangle 686",
    width: 0.54,
    height: 9.451,
    transform: "translate(206.26 108.711)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2475",
    "data-name": "Path 2475",
    d: "M2861.458,1287.25l-2.658,19.076h5.315Z",
    transform: "translate(-2654.786 -1195.389)",
    fill: "#3c8f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2476",
    "data-name": "Path 2476",
    d: "M2861.16,1511.311l4.769-1.5-.072-.517-4.618,1.455Z",
    transform: "translate(-2656.979 -1401.583)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2477",
    "data-name": "Path 2477",
    d: "M2872.93,1433.454l3.16-1-.072-.517-3.009.949Z",
    transform: "translate(-2667.908 -1329.753)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_687",
    "data-name": "Rectangle 687",
    width: 0.458,
    height: 5.076,
    transform: "translate(201.693 109.384)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2478",
    "data-name": "Path 2478",
    d: "M2810.045,1394.79l-1.5,12.081h2.99Z",
    transform: "translate(-2608.122 -1295.254)",
    fill: "#3c8f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2479",
    "data-name": "Path 2479",
    d: "M2816.15,1495.715l2.131,1.828-.082-.662-1.983-1.7Z",
    transform: "translate(-2615.18 -1388.48)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2480",
    "data-name": "Path 2480",
    d: "M2820.74,1459.645l1.305.447-.062-.5-1.187-.406Z",
    transform: "translate(-2619.443 -1355.059)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2481",
    "data-name": "Path 2481",
    d: "M2583.275,1557.808a4.15,4.15,0,0,0,.057-.678c0-2.569-2.407-4.65-5.377-4.65s-5.375,2.082-5.375,4.65a3.994,3.994,0,0,0,.057.678Z",
    transform: "translate(-2388.992 -1441.691)",
    fill: "#3c8f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2482",
    "data-name": "Path 2482",
    d: "M2668.535,1513.344a8.111,8.111,0,0,0,.056-.956c0-3.622-2.406-6.558-5.376-6.558s-5.376,2.937-5.376,6.558a8.163,8.163,0,0,0,.056.956Z",
    transform: "translate(-2468.168 -1398.37)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2483",
    "data-name": "Path 2483",
    d: "M2779.387,1598.108a4.1,4.1,0,0,1-.057-.678c0-2.569,2.407-4.65,5.376-4.65s5.376,2.085,5.376,4.65a4.146,4.146,0,0,1-.056.678Z",
    transform: "translate(-2580.988 -1479.115)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2484",
    "data-name": "Path 2484",
    d: "M2658.631,1569.664a6.459,6.459,0,0,1-.071-.956,6.82,6.82,0,0,1,13.63,0,6.33,6.33,0,0,1-.071.956Z",
    transform: "translate(-2468.836 -1450.671)",
    fill: "#3c8f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2485",
    "data-name": "Path 2485",
    d: "M2570.192,1562.15a5.857,5.857,0,0,0-4.671,2.392,7.736,7.736,0,0,0-1.784-.206c-3.34,0-6.048,2.082-6.048,4.65a3.63,3.63,0,0,0,.064.678h18.424a7.158,7.158,0,0,0,.064-.956A6.322,6.322,0,0,0,2570.192,1562.15Z",
    transform: "translate(-2375.165 -1450.671)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2486",
    "data-name": "Path 2486",
    d: "M2225.717,1687.31a3.33,3.33,0,0,1,.013.525c0,.017-.011.039-.019.063a.829.829,0,0,0,.043.293h.9c.049,0,.016-.031-.024-.059a1.77,1.77,0,0,0-.326-.175c-.014-.006-.063-.037-.081-.048a.651.651,0,0,1-.131-.112,1.148,1.148,0,0,1-.072-.42Z",
    transform: "translate(-2066.872 -1566.899)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2487",
    "data-name": "Path 2487",
    d: "M2225.645,1695.574a.813.813,0,0,1-.513-.013c-.025.071-.072.316-.043.316.226,0,.417.043,1.064.033.023,0,.021-.081.006-.1A4.792,4.792,0,0,0,2225.645,1695.574Z",
    transform: "translate(-2066.291 -1574.561)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2488",
    "data-name": "Path 2488",
    d: "M2240.16,1677.331a3.327,3.327,0,0,1,.229.472.492.492,0,0,1,.009.065.841.841,0,0,0,.161.249l.822-.371c.044-.021,0-.035-.046-.044a1.753,1.753,0,0,0-.37-.024c-.015,0-.071-.007-.093-.01a.64.64,0,0,1-.166-.048c-.089-.037-.242-.35-.242-.35Z",
    transform: "translate(-2080.294 -1557.576)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2489",
    "data-name": "Path 2489",
    d: "M2165.22,1582.184a.7.7,0,0,0-.62-.344c-.775,0-.874,1-1.367,1.381-.149.115-.313.21-.454.333a.662.662,0,0,0,.038.24,1,1,0,0,0,.119.225l.209-.121-.091.263a2.788,2.788,0,0,0,.677.47,2.447,2.447,0,0,0,1.062.275,8.909,8.909,0,0,0,.338-.864,3.541,3.541,0,0,0,.246-1.06A1.621,1.621,0,0,0,2165.22,1582.184Z",
    transform: "translate(-2008.435 -1468.956)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2490",
    "data-name": "Path 2490",
    d: "M2243.972,1682.727a.816.816,0,0,1-.472.2c.008.075.067.317.092.305.206-.094.4-.134.983-.413.021-.009-.015-.081-.036-.091A4.273,4.273,0,0,0,2243.972,1682.727Z",
    transform: "translate(-2083.396 -1562.634)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2491",
    "data-name": "Path 2491",
    d: "M2198.7,1614.873c-.057-.009-.193-.106-.24-.116l-.153-.024c-.042-.157-.255-1.013-.28-1.264-.026-.272-.214-1.449-.214-1.449l-.5.091s.206.9.264,1.344a6.027,6.027,0,0,0,.516,1.315v.006c.008.133.071.089.071.089l.1.027s.369.035.393.044S2198.752,1614.884,2198.7,1614.873Z",
    transform: "translate(-2040.503 -1496.982)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2492",
    "data-name": "Path 2492",
    d: "M2193.549,1603.32c.352.12.5,1.011.5,1.011s-.552.155-.694.071c0,0-.161-.714-.214-.687Z",
    transform: "translate(-2036.63 -1488.903)",
    fill: "#96d9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2493",
    "data-name": "Path 2493",
    d: "M2181.938,1602.277h0a.13.13,0,0,0,.036-.007.889.889,0,0,1,.349.071c.135.057.214.561.205,1.108-.005.083-.072,1.373-.072,1.377a2.569,2.569,0,0,1-1.189.066c-.067-.088-.119-1.617-.151-1.67l-.064-.935A8.183,8.183,0,0,1,2181.938,1602.277Z",
    transform: "translate(-2025.403 -1487.928)",
    fill: "#96d9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2494",
    "data-name": "Path 2494",
    d: "M2188,1595.349a2.423,2.423,0,0,1,.05.452c-.012.128.048.54.319.542s.051-.524.025-.649a4.742,4.742,0,0,1-.031-.513Z",
    transform: "translate(-2031.857 -1481.344)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2495",
    "data-name": "Path 2495",
    d: "M2188.329,1595.374c0-.106-.006-.194-.006-.194l-.363.169s.013.066.026.151A.318.318,0,0,0,2188.329,1595.374Z",
    transform: "translate(-2031.82 -1481.344)",
    fill: "#f47458",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2496",
    "data-name": "Path 2496",
    d: "M2183.405,1584.445a.451.451,0,0,0-.191.246.6.6,0,0,0,.369.707c.362.1.519-.239.443-.508S2183.79,1584.281,2183.405,1584.445Z",
    transform: "translate(-2027.398 -1471.335)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2497",
    "data-name": "Path 2497",
    d: "M2193.437,1587.985c-.007.072-.047.128-.089.124s-.071-.066-.063-.138.047-.127.089-.123S2193.443,1587.913,2193.437,1587.985Z",
    transform: "translate(-2036.762 -1474.534)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2498",
    "data-name": "Path 2498",
    d: "M2181.721,1584.7s-.065.484-.223.571-.09.3-.09.3-.143-.5-.019-.659A.686.686,0,0,1,2181.721,1584.7Z",
    transform: "translate(-2025.671 -1471.612)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2499",
    "data-name": "Path 2499",
    d: "M2182.463,1592.726c.043.064.042.138,0,.166s-.112,0-.154-.062-.042-.138,0-.166S2182.421,1592.664,2182.463,1592.726Z",
    transform: "translate(-2026.543 -1478.997)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2500",
    "data-name": "Path 2500",
    d: "M2188.945,1594.06l-.255.064a.115.115,0,0,0,.143.072C2188.971,1594.166,2188.945,1594.06,2188.945,1594.06Z",
    transform: "translate(-2032.498 -1480.304)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2501",
    "data-name": "Path 2501",
    d: "M2160.284,1615.475c0-.011.014-.012.024-.013a2.491,2.491,0,0,0,.3-.032.211.211,0,0,0,.048-.013.126.126,0,0,1,.083-.006.164.164,0,0,0,.046,0,2.757,2.757,0,0,0,.267-.071.042.042,0,0,0,.034-.034c.064-.291.2-.944.214-1.157.017-.273.167-1.508.167-1.508l.508.125s-.179.913-.222,1.356a5.928,5.928,0,0,1-.45,1.284.213.213,0,0,1-.19.168.062.062,0,0,0-.039.023.287.287,0,0,1-.062.057.154.154,0,0,0-.042.044c-.021.032-.039.066-.057.1s-.025.03-.044.025a.041.041,0,0,1-.03-.043.2.2,0,0,1,.027-.1.054.054,0,0,0-.007-.072.21.21,0,0,0-.039-.041.067.067,0,0,0-.053-.017.915.915,0,0,1-.108.024l-.031.007-.016,0s-.056.009-.071.01h-.06a.343.343,0,0,1-.059-.007.072.072,0,0,1-.048-.017.017.017,0,0,1-.008-.019.021.021,0,0,1,.017-.013.383.383,0,0,0,.071-.014h-.1a.088.088,0,0,1-.065-.026A.017.017,0,0,1,2160.284,1615.475Z",
    transform: "translate(-2006.118 -1497.558)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2502",
    "data-name": "Path 2502",
    d: "M2175.034,1602.5c-.249-.045-.474,1.071-.474,1.071s.552.155.695.071c0,0,.16-.714.218-.687Z",
    transform: "translate(-2019.376 -1488.143)",
    fill: "#96d9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2503",
    "data-name": "Path 2503",
    d: "M2182.553,1634.6v.2l1.91.4.475,1.427-.265-.18.062,2.194h-.4a6.61,6.61,0,0,1-.468-2.766l-2.115.033a1.019,1.019,0,0,1-.464-1.487Z",
    transform: "translate(-2025.49 -1517.793)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2504",
    "data-name": "Path 2504",
    d: "M2200.88,1639.71a15.021,15.021,0,0,1,2.123.122c.141.109,1.2,2.8,1.2,2.8l-.461.172s-.917-1.528-.965-1.637a4.735,4.735,0,0,0-.539-.987C2202.1,1640.1,2200.88,1639.71,2200.88,1639.71Z",
    transform: "translate(-2043.818 -1522.696)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2505",
    "data-name": "Path 2505",
    d: "M2116.243,1604.538c-.174-.066-1.641-.622-1.7-.665s-.827-.969-.827-.969l.534-.214.684.879c.051.029,1,.537,1,.537s.172.1.277.149l.08-.009a.625.625,0,0,0,.129-.04.816.816,0,0,1,.167-.043l.12,0a.414.414,0,0,1,.093.006.154.154,0,0,0,.054-.008.031.031,0,0,1,.032.012.03.03,0,0,1,0,.034.129.129,0,0,1-.071.038c-.062.017-.163.008-.16.017a1.972,1.972,0,0,0,.177.092,2.033,2.033,0,0,1,.23.123c.029.029.017.052-.007.053s-.28-.1-.28-.1-.033-.012-.026.006.242.108.275.128.045.049.011.062a1.317,1.317,0,0,1-.285-.1s-.031-.014-.031,0,.2.088.214.1a.028.028,0,0,1-.02.05,1.3,1.3,0,0,1-.257-.1s-.019,0-.015.007a1.642,1.642,0,0,1,.183.108.019.019,0,0,1,0,.015.02.02,0,0,1-.009.013c-.031.027-.185-.072-.268-.091S2116.249,1604.541,2116.243,1604.538Z",
    transform: "translate(-1962.878 -1488.318)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2506",
    "data-name": "Path 2506",
    d: "M2121.11,1597s.132.025.357.41c.208.357.394.761.394.761l-.375.395s-.274-.846-.3-.873S2121.11,1597,2121.11,1597Z",
    transform: "translate(-1969.741 -1483.034)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2507",
    "data-name": "Path 2507",
    d: "M2137.986,1691.65l-.02.337c-.007.043-.036.148-.036.187,0,.143.685-.124.531-.188-.014-.006-.087-.05-.091-.1-.007-.076-.025-.231-.025-.231Z",
    transform: "translate(-1985.36 -1570.93)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2508",
    "data-name": "Path 2508",
    d: "M2154.257,1691.018l-.02.337a1.876,1.876,0,0,0-.037.187c0,.143.686-.124.532-.188-.014-.006-.118-.024-.123-.071-.006-.076-.02-.312-.02-.312Z",
    transform: "translate(-2000.469 -1570.298)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2509",
    "data-name": "Path 2509",
    d: "M2122.618,1642.22l1.642.007s.74-.019.856.239.125,3.324.125,3.324a2.516,2.516,0,0,1-.407,0l-.488-1.713a1.4,1.4,0,0,1-.048-.513l.042-.458-.676.035s-.766-.012-1.019-.269S2122.618,1642.22,2122.618,1642.22Z",
    transform: "translate(-1971.055 -1525.027)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2510",
    "data-name": "Path 2510",
    d: "M2105.819,1639.67l1.762.109s.758.062.875.32a30.524,30.524,0,0,1-.039,3.322,3.3,3.3,0,0,1-.445,0c0-.02-.214-1.261-.312-1.734a1.728,1.728,0,0,1-.033-.457l.046-.5a16.2,16.2,0,0,1-1.951-.1C2105.471,1640.376,2105.819,1639.67,2105.819,1639.67Z",
    transform: "translate(-1955.367 -1522.659)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2511",
    "data-name": "Path 2511",
    d: "M2102.968,1596.975a4.53,4.53,0,0,0-.714.036,1.777,1.777,0,0,0-.379.053c-.128.058-.379.126-.278.722.071.428.233,1.825.333,2.542l1.784-.2C2103.346,1598.713,2103.21,1597,2102.968,1596.975Z",
    transform: "translate(-1951.599 -1483.01)",
    fill: "#fcf5eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2512",
    "data-name": "Path 2512",
    d: "M2110.784,1589.66l-.164.558s.279.323.474.291c.163-.026.087-.262.087-.262a1.558,1.558,0,0,1,.007-.472C2111.236,1589.62,2110.784,1589.66,2110.784,1589.66Z",
    transform: "translate(-1959.999 -1476.214)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2513",
    "data-name": "Path 2513",
    d: "M2112.579,1589.9a1.043,1.043,0,0,0,.314.148.833.833,0,0,1,.023-.228c.022-.071-.062-.1-.16-.113a2.388,2.388,0,0,0-.245,0l-.031.108A.459.459,0,0,0,2112.579,1589.9Z",
    transform: "translate(-1961.727 -1476.26)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2514",
    "data-name": "Path 2514",
    d: "M2111.549,1575.361c-.013,0-.147.677.015.878s.5.286.629.143a1.107,1.107,0,0,0-.075-1.108C2111.859,1575.062,2111.549,1575.361,2111.549,1575.361Z",
    transform: "translate(-1960.802 -1462.787)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2515",
    "data-name": "Path 2515",
    d: "M2107.819,1570.973a.757.757,0,0,0-.409.2.5.5,0,0,0-.375.265.562.562,0,0,0,.1.737.439.439,0,0,1,.168.334l.036-.088a.5.5,0,0,0,.037-.208.409.409,0,0,0-.023-.128c-.04-.1.108-.16.154-.24.036-.062.045-.208.1-.311l.063-.076a.37.37,0,0,1,.273-.06C2108.08,1571.439,2108.092,1570.934,2107.819,1570.973Z",
    transform: "translate(-1956.583 -1458.862)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2516",
    "data-name": "Path 2516",
    d: "M2112.411,1582.975c0,.084-.045.151-.093.148s-.084-.071-.081-.156.046-.15.094-.148S2112.415,1582.888,2112.411,1582.975Z",
    transform: "translate(-1961.5 -1469.865)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2517",
    "data-name": "Path 2517",
    d: "M2097.021,1613.41l.479.149s-.09.418-.091.468c0,0,.816.437,1.158.571l-.009.3c-.067-.025-.121-.051-.154-.062l-1.11-.341s-.411-.147-.425-.226S2097.021,1613.41,2097.021,1613.41Z",
    transform: "translate(-1947.229 -1498.273)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2518",
    "data-name": "Path 2518",
    d: "M2097,1599.259a9.57,9.57,0,0,1,.356-1.177.352.352,0,0,1,.571-.108c.175.164-.327,1.412-.327,1.412Z",
    transform: "translate(-1947.351 -1483.843)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2519",
    "data-name": "Path 2519",
    d: "M2138.145,1695.837s-.161.044-.243.055-.191-.083-.249-.058-.062.279-.062.279a5.559,5.559,0,0,0,1.106,0C2138.792,1696.083,2138.476,1695.941,2138.145,1695.837Z",
    transform: "translate(-1985.045 -1574.812)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2520",
    "data-name": "Path 2520",
    d: "M2154.454,1695.837s-.161.044-.243.055-.191-.083-.25-.058-.062.279-.062.279a5.554,5.554,0,0,0,1.105,0C2155.1,1696.083,2154.783,1695.941,2154.454,1695.837Z",
    transform: "translate(-2000.19 -1574.812)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2521",
    "data-name": "Path 2521",
    d: "M2117.79,1588.2h.237a.1.1,0,0,1-.11.095C2117.79,1588.3,2117.79,1588.2,2117.79,1588.2Z",
    transform: "translate(-1966.657 -1474.862)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2522",
    "data-name": "Path 2522",
    d: "M2129.086,1621.918c-.006.05.017.094.052.1s.071-.033.076-.083-.017-.1-.052-.1S2129.093,1621.865,2129.086,1621.918Zm.1-.031c0,.011-.019.019-.037.016s-.033-.014-.031-.026.018-.019.037-.017.033.011.032.023Zm-.092.058c0-.019.026-.03.053-.027s.046.021.044.039-.026.03-.053.026-.047-.023-.044-.041Z",
    transform: "translate(-1977.147 -1506.097)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2523",
    "data-name": "Path 2523",
    d: "M2123.924,1624.053a.22.22,0,0,1,.008.095l-.086.665a.071.071,0,0,1-.028.05.072.072,0,0,1-.055.014l-.38-.049a.073.073,0,0,1-.05-.027.072.072,0,0,1-.014-.056l.086-.665a.223.223,0,0,1,.032-.09Z",
    transform: "translate(-1971.79 -1508.098)",
    fill: "#7f1ca0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2524",
    "data-name": "Path 2524",
    d: "M2123.924,1624.053a.22.22,0,0,1,.008.095l-.086.665a.071.071,0,0,1-.028.05.072.072,0,0,1-.055.014l-.38-.049a.073.073,0,0,1-.05-.027.072.072,0,0,1-.014-.056l.086-.665a.223.223,0,0,1,.032-.09Z",
    transform: "translate(-1971.79 -1508.098)",
    fill: "#7f1ca0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2525",
    "data-name": "Path 2525",
    d: "M2123.4,1624.089l-.086.665a.068.068,0,0,0,.014.055.073.073,0,0,0,.05.028l.38.049a.071.071,0,0,0,.055-.014.072.072,0,0,0,.028-.05l.086-.665a.216.216,0,0,0-.008-.095l-.487-.063A.223.223,0,0,0,2123.4,1624.089Z",
    transform: "translate(-1971.79 -1508.107)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2526",
    "data-name": "Path 2526",
    d: "M2128.224,1625.451l.086-.666a.216.216,0,0,0-.008-.095l.1.014a.227.227,0,0,1,.008.095l-.086.665a.07.07,0,0,1-.028.05.072.072,0,0,1-.055.014l-.1-.013A.075.075,0,0,0,2128.224,1625.451Z",
    transform: "translate(-1976.269 -1508.748)",
    fill: "#96d9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2527",
    "data-name": "Path 2527",
    d: "M2123.4,1624.089l-.086.665a.068.068,0,0,0,.014.055.073.073,0,0,0,.05.028l.156.02a.072.072,0,0,1-.051-.027.073.073,0,0,1-.015-.056l.087-.665a.221.221,0,0,1,.032-.09l-.154-.019A.223.223,0,0,0,2123.4,1624.089Z",
    transform: "translate(-1971.79 -1508.107)",
    fill: "#3c8f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2528",
    "data-name": "Path 2528",
    d: "M2125,1623.559l.488.063h0a.04.04,0,0,0-.035-.043l-.409-.053A.039.039,0,0,0,2125,1623.559Z",
    transform: "translate(-1973.353 -1507.666)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_688",
    "data-name": "Rectangle 688",
    width: 0.083,
    height: 0.532,
    transform: "translate(151.545 116.609) rotate(-82.59)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2529",
    "data-name": "Path 2529",
    d: "M2120.455,1627.661a1.168,1.168,0,0,1,.186-.154.268.268,0,0,1,.114-.033s.088,0,.095.016a.045.045,0,0,1-.023.051c-.016.007-.051,0-.067.012a.134.134,0,0,0-.036.079,1.119,1.119,0,0,0,.259,0l.1-.015c.027,0,.082-.023.082-.023s.089-.021.094.007-.071.058-.148.086a1.594,1.594,0,0,0-.169.056c0,.021.143.013.143.013a.459.459,0,0,1,.1-.019c.039-.019.11-.031.113,0a.649.649,0,0,1-.091.051s-.063.017-.094.027a1.592,1.592,0,0,1-.17.029c-.031.008-.018.015-.02.019a.677.677,0,0,0,.1-.006.545.545,0,0,0,.094-.006.659.659,0,0,1,.1-.012c.071,0,.063.044-.005.059l-.083.019c-.112.024-.217.021-.219.034a.942.942,0,0,0,.191.009s.1.027,0,.05a.833.833,0,0,1-.214.021.8.8,0,0,1-.224-.01c-.072-.02-.17-.051-.219-.066Z",
    transform: "translate(-1969.118 -1511.334)",
    fill: "#8c716c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2530",
    "data-name": "Path 2530",
    d: "M2123.976,1626.656l-.026.2a.647.647,0,0,0,.157,0l.013-.1-.009-.081-.035-.046Z",
    transform: "translate(-1972.378 -1510.55)",
    fill: "#3c8f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2531",
    "data-name": "Path 2531",
    d: "M757.1,1616.7l.206.583s-.511.132-.524.136-.124-.571-.124-.571Z",
    transform: "translate(-702.662 -1501.328)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2532",
    "data-name": "Path 2532",
    d: "M760.846,1680.5s-.376.462-.379.5a1.934,1.934,0,0,0,.06.519c.045.041.176.071.134.113a1.268,1.268,0,0,1-.441.018c-.048,0-.107-.391-.126-.448a.878.878,0,0,1-.071-.327.489.489,0,0,1,.151-.143,4.551,4.551,0,0,0,.415-.524Z",
    transform: "translate(-705.78 -1560.306)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2533",
    "data-name": "Path 2533",
    d: "M759.491,1687.59s.253.728.352.763c.026.009.152.033.176.09a.26.26,0,0,1,0,.072h-.527s-.066-.321-.093-.462a2.173,2.173,0,0,1-.124-.375C759.29,1687.646,759.491,1687.59,759.491,1687.59Z",
    transform: "translate(-705.09 -1567.159)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2534",
    "data-name": "Path 2534",
    d: "M803.23,1684.559s.307.443.28.583c-.014.075-.078.173-.041.243a.188.188,0,0,0,.079.088l.959.016c.052,0,.018-.034-.024-.065a1.892,1.892,0,0,0-.345-.195c-.014-.007-.066-.042-.085-.053a.69.69,0,0,1-.138-.123,7.918,7.918,0,0,1-.372-.714Z",
    transform: "translate(-745.909 -1564.141)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2535",
    "data-name": "Path 2535",
    d: "M746.186,1637.9a6.817,6.817,0,0,1-.477.514c-.1.07-1.029,1.825-1.029,1.825l.332.248s.833-1.061,1.224-1.629a7.522,7.522,0,0,0,.4-.742.4.4,0,0,0-.058-.509c-.017-.017-.036-.034-.057-.051a10.175,10.175,0,0,0-2.261-.522l-1.262.126s1.031.739,1.07.759,1.424.226,1.453.226S746.186,1637.9,746.186,1637.9Z",
    transform: "translate(-689.977 -1520.207)",
    fill: "#e25a44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2536",
    "data-name": "Path 2536",
    d: "M740.284,1638.359s-.214.664.109.974,2.254.275,2.889.275c0,0,.26.728.285.846s1.289,1.641,1.289,1.641l.347-.226s-1.356-2.7-1.463-2.813a15.12,15.12,0,0,0-1.992-.7A6.345,6.345,0,0,0,740.284,1638.359Z",
    transform: "translate(-687.39 -1521.396)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2537",
    "data-name": "Path 2537",
    d: "M754.88,1599.58c-.236-.734-.5-.7-.5-.7l.2,1.542c.143-.041.336-.132.482-.174A6.785,6.785,0,0,0,754.88,1599.58Z",
    transform: "translate(-700.545 -1484.777)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538",
    "data-name": "Path 2538",
    d: "M737.536,1596.981s-.435-.029-.608.163.382,1.713.414,1.961a3.58,3.58,0,0,1-.16.9s1.023.214,1.316.013c0,0,.031-1.762,0-1.937a5.152,5.152,0,0,0-.357-.957A2.379,2.379,0,0,0,737.536,1596.981Z",
    transform: "translate(-684.307 -1483.015)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539",
    "data-name": "Path 2539",
    d: "M756.112,1610.11h-1.4a.1.1,0,0,0-.085.066l-.591,1.9a.046.046,0,0,0,.044.066h1.4a.1.1,0,0,0,.085-.066l.591-1.9a.047.047,0,0,0,0-.045A.048.048,0,0,0,756.112,1610.11Z",
    transform: "translate(-700.221 -1495.208)",
    fill: "#3c8f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2540",
    "data-name": "Path 2540",
    d: "M771.637,1617.608a.1.1,0,0,0,.056.124.093.093,0,0,0,.071-.018.1.1,0,0,0,.037-.063.087.087,0,1,0-.164-.044Z",
    transform: "translate(-716.565 -1502.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2541",
    "data-name": "Path 2541",
    d: "M806.749,1696.1a.981.981,0,0,1-.627-.025.534.534,0,0,0-.05.268c.026.079.064.1.1.1.266.007.975.016,1.178.019a.034.034,0,0,0,.026-.056A4.929,4.929,0,0,0,806.749,1696.1Z",
    transform: "translate(-748.543 -1575.034)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542",
    "data-name": "Path 2542",
    d: "M756.37,1625.046a1.065,1.065,0,0,1,.154-.15.243.243,0,0,1,.1-.038s.078-.011.086.007a.04.04,0,0,1-.017.047c-.013.008-.045.009-.058.016a.123.123,0,0,0-.027.071,1,1,0,0,0,.231-.021s.065-.015.086-.021.071-.026.071-.026.077-.026.084,0-.059.057-.126.088a1.382,1.382,0,0,0-.143.062c0,.019.129,0,.129,0a.41.41,0,0,1,.085-.024c.034-.02.1-.037.1-.005a.571.571,0,0,1-.077.052s-.056.02-.081.031a1.523,1.523,0,0,1-.15.038c-.032.011-.015.015-.016.018a.737.737,0,0,0,.086-.012.506.506,0,0,0,.083-.013.634.634,0,0,1,.088-.019c.066-.009.06.034,0,.053l-.071.022c-.1.03-.192.036-.193.047a.917.917,0,0,0,.171-.007s.1.016.008.043a.736.736,0,0,1-.189.036.7.7,0,0,1-.2.009c-.064-.011-.156-.031-.2-.041Z",
    transform: "translate(-702.393 -1508.902)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2543",
    "data-name": "Path 2543",
    d: "M734.827,1614.49l.439.094s-.049.376-.046.42c0,0,.762.323,1.077.417l.015.265c-.061-.016-.111-.035-.143-.042-.06-.014-1.015-.214-1.015-.214s-.378-.1-.4-.166S734.827,1614.49,734.827,1614.49Z",
    transform: "translate(-682.32 -1499.276)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2544",
    "data-name": "Path 2544",
    d: "M733.883,1599.059a6.665,6.665,0,0,1,.083-1.275c.1-.247.453-.408.642-.265s-.108,1.54-.108,1.54Z",
    transform: "translate(-681.51 -1483.465)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2545",
    "data-name": "Path 2545",
    d: "M738.958,1574.339c0-.488-.379-.894-.856-.727a1.055,1.055,0,0,0-.337.2c-.22.214-.31.51-.535.719a1.97,1.97,0,0,0,.233.2l.143-.143-.071.2a2.9,2.9,0,0,0,1.252.45A2.6,2.6,0,0,0,738.958,1574.339Z",
    transform: "translate(-684.619 -1461.28)",
    fill: "#184655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2546",
    "data-name": "Path 2546",
    d: "M745.865,1588.549a.142.142,0,0,1-.006.036,3.7,3.7,0,0,1-.143.562c-.061.119.209.5.469.45.078-.013-.065-.347-.058-.382.014-.071.031-.16.049-.254.01-.054.021-.108.031-.158l.051-.262Z",
    transform: "translate(-692.49 -1475.178)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2547",
    "data-name": "Path 2547",
    d: "M747.654,1588.585a.089.089,0,0,1,.006-.036l.39-.009-.051.262c-.01.051-.02.1-.031.157a.353.353,0,0,1-.186-.1.5.5,0,0,1-.143-.214C747.647,1588.624,747.65,1588.6,747.654,1588.585Z",
    transform: "translate(-694.286 -1475.178)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2548",
    "data-name": "Path 2548",
    d: "M746.959,1576.89a.346.346,0,0,0-.314.086.723.723,0,0,0-.076.879c.248.3.571.049.652-.25S747.373,1576.942,746.959,1576.89Z",
    transform: "translate(-693.179 -1464.351)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2549",
    "data-name": "Path 2549",
    d: "M756.395,1584.945c-.044.063-.106.091-.138.065s-.025-.1.018-.161.106-.091.138-.065S756.438,1584.883,756.395,1584.945Z",
    transform: "translate(-702.268 -1471.68)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2550",
    "data-name": "Path 2550",
    d: "M744.7,1576.082s-.305.409-.482.4-.233.228-.233.228.138-.535.325-.615a.63.63,0,0,1,.39-.017Z",
    transform: "translate(-690.896 -1463.587)",
    fill: "#184655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2551",
    "data-name": "Path 2551",
    d: "M745.271,1581.832c0,.081-.036.149-.086.152s-.094-.06-.1-.143.035-.149.086-.153S745.268,1581.75,745.271,1581.832Z",
    transform: "translate(-691.916 -1468.815)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2552",
    "data-name": "Path 2552",
    d: "M750.19,1588.371l-.22-.081a.105.105,0,0,0,.071.126C750.158,1588.463,750.19,1588.371,750.19,1588.371Z",
    transform: "translate(-696.446 -1474.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2553",
    "data-name": "Path 2553",
    d: "M777.57,1620.266l.035.291h.005a.423.423,0,0,0,.118-.1l.219-.278-.037-.24a.721.721,0,0,0-.2-.058c-.026.013.087.088.087.088s-.09-.035-.1-.013.071.087.071.087Z",
    transform: "translate(-722.08 -1504.278)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2554",
    "data-name": "Path 2554",
    d: "M776.01,1622.14c.005.011-.173.559-.173.559l-.157-.279a2.288,2.288,0,0,1,.175-.243Z",
    transform: "translate(-720.325 -1506.38)",
    fill: "#3c8f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2555",
    "data-name": "Path 2555",
    d: "M1021.932,1612.478c-.019-.029.13-.1.13-.133s-.206.019-.22-.008c-.026-.048.222-.071.211-.1s-.268-.011-.252-.061.267.016.267-.015-.24-.039-.252-.1c-.006-.034.406.067.443.037s-.089-.164-.062-.2.214.285.236.291a5.249,5.249,0,0,0,.77.147c.006-.065.114-.38.119-.441.115.043.2-.01.315.026a3.311,3.311,0,0,1-.208.763c-.137.113-.861-.221-1-.273s-.2-.006-.291-.011S1021.952,1612.505,1021.932,1612.478Z",
    transform: "translate(-948.881 -1496.871)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2556",
    "data-name": "Path 2556",
    d: "M1031.034,1603.05c-.181.062-.379.642-.386.679a3.185,3.185,0,0,0-.063.338h0c0,.024-.007.043-.009.053a5,5,0,0,1-.765-.175l-.071.254c.016,0,.923.382,1.06.269a1.565,1.565,0,0,0,.126-.375.636.636,0,0,0,.278-.039s.155-.691.214-.667Z",
    transform: "translate(-956.254 -1488.652)",
    fill: "#96d9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2557",
    "data-name": "Path 2557",
    d: "M1049.608,1579.807s-.126-.143.018-.6a.58.58,0,0,1,.973-.168.939.939,0,0,1,.186.978.8.8,0,0,1-.418.313Z",
    transform: "translate(-974.657 -1466.174)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2558",
    "data-name": "Path 2558",
    d: "M1009.328,1683.88a3.248,3.248,0,0,0-.012.509.5.5,0,0,0,.018.062.806.806,0,0,1-.041.285l-.874,0c-.048,0-.016-.03.023-.058a1.729,1.729,0,0,1,.316-.17c.014-.007.061-.036.079-.046a.654.654,0,0,0,.126-.109,1.119,1.119,0,0,0,.071-.407Z",
    transform: "translate(-936.431 -1563.714)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2559",
    "data-name": "Path 2559",
    d: "M991.951,1674.192a3.192,3.192,0,0,0-.222.458.407.407,0,0,0-.009.063.841.841,0,0,1-.156.242l-.8-.363c-.044-.019,0-.034.045-.043a1.764,1.764,0,0,1,.357-.023c.014,0,.071-.007.091-.009a.629.629,0,0,0,.16-.046c.087-.037.236-.341.236-.341Z",
    transform: "translate(-920.045 -1554.66)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2560",
    "data-name": "Path 2560",
    d: "M990.265,1679.431a.791.791,0,0,0,.459.194c-.008.071-.065.308-.089.3-.2-.091-.386-.131-.953-.4-.02-.009.014-.079.035-.088A4.179,4.179,0,0,1,990.265,1679.431Z",
    transform: "translate(-919.049 -1559.574)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2561",
    "data-name": "Path 2561",
    d: "M1015.586,1632.7v.2l-1.855.39-.46,1.382.256-.175-.059,2.129h.39a6.413,6.413,0,0,0,.454-2.683l2.052.031a.988.988,0,0,0,.45-1.442Z",
    transform: "translate(-940.96 -1516.029)",
    fill: "#00213d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2562",
    "data-name": "Path 2562",
    d: "M1003.811,1637.69a14.505,14.505,0,0,0-2.06.119c-.137.105-1.161,2.719-1.161,2.719l.447.167s.889-1.483.936-1.589a4.611,4.611,0,0,1,.523-.958C1002.627,1638.068,1003.811,1637.69,1003.811,1637.69Z",
    transform: "translate(-929.185 -1520.82)",
    fill: "#223c56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2563",
    "data-name": "Path 2563",
    d: "M1019.255,1604.3a6.529,6.529,0,0,1-.181-.937h0c.049-.357.094-.725.111-.753l-.041-.836s-.033-.173-.071-.181a5.99,5.99,0,0,0-.776-.113h0q-.194.052-.382.123c-.131.055-.2.487-.189,1.018,0,.061.039.771.058,1.13-.014.071-1.919.353-2.02.416a.274.274,0,0,0-.123.154c.4-.143,1,1.427,1,1.427s1.922-.521,2.175-.6A.748.748,0,0,0,1019.255,1604.3Z",
    transform: "translate(-943.161 -1487.194)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2564",
    "data-name": "Path 2564",
    d: "M1043.07,1621.987l-.09-.214c-.025,0-.194.007-.2,0a2.214,2.214,0,0,0-.224-.123c-.019-.007-.076-.016-.081,0a.029.029,0,0,0,.016.037l.041.018c.013,0,.05.027.051.043a.937.937,0,0,1-.214.011s-.062,0-.082-.008l-.071-.014s-.086-.013-.089.01.28.085.28.1-.119.017-.119.017a.39.39,0,0,0-.081-.011c-.033-.013-.1-.015-.1.014a.487.487,0,0,0,.083.033l.079.017a1.336,1.336,0,0,0,.143.015c.026,0,.016.011.017.014a.555.555,0,0,1-.081,0,.377.377,0,0,1-.078,0,.586.586,0,0,0-.083,0c-.062,0-.051.039.006.049l.071.011c.094.014.181.006.183.016a.834.834,0,0,1-.158.017s-.086.027,0,.041a.517.517,0,0,0,.18,0,.67.67,0,0,0,.183-.022A3.721,3.721,0,0,1,1043.07,1621.987Z",
    transform: "translate(-967.741 -1505.921)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2565",
    "data-name": "Path 2565",
    d: "M1007.975,1691.484a.793.793,0,0,0,.5-.014c.024.072.071.307.042.307-.22,0-.405.042-1.033.031-.023,0-.02-.077,0-.094A4.093,4.093,0,0,1,1007.975,1691.484Z",
    transform: "translate(-935.57 -1570.762)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2566",
    "data-name": "Path 2566",
    d: "M1051.241,1591.354a1.459,1.459,0,0,0,.091.63s-.6.469-.812-.038a2.644,2.644,0,0,0,.156-.6C1050.744,1590.93,1051.241,1591.354,1051.241,1591.354Z",
    transform: "translate(-975.551 -1477.613)",
    fill: "#96d9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2567",
    "data-name": "Path 2567",
    d: "M1050.679,1583.9a.436.436,0,0,1,.251.167.586.586,0,0,1-.123.764c-.3.208-.55-.062-.564-.332S1050.275,1583.868,1050.679,1583.9Z",
    transform: "translate(-975.293 -1470.869)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2568",
    "data-name": "Path 2568",
    d: "M1052.707,1594.48l.239.026a.106.106,0,0,1-.121.083C1052.7,1594.579,1052.707,1594.48,1052.707,1594.48Z",
    transform: "translate(-977.582 -1480.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2569",
    "data-name": "Path 2569",
    d: "M1050.45,1584.238s.143-.286.374-.259.383.33.383.33a.413.413,0,0,0-.357-.41A.364.364,0,0,0,1050.45,1584.238Z",
    transform: "translate(-975.486 -1470.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2570",
    "data-name": "Path 2570",
    d: "M1054.285,1604.159c-.041-.164-.285-1.115-.591-1.11,0,0-.3.017-.187.428l.367.815a4.94,4.94,0,0,1-.954.18l.066.29s1.15.01,1.322-.259A.45.45,0,0,0,1054.285,1604.159Z",
    transform: "translate(-977.78 -1488.652)",
    fill: "#96d9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2571",
    "data-name": "Path 2571",
    d: "M1045.571,1630.768a2.944,2.944,0,0,1,1.107.149,2.106,2.106,0,0,0-1.118-.343Z",
    transform: "translate(-970.945 -1514.212)",
    fill: "#50bfa5",
    opacity: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNothingFound);
export default __webpack_public_path__ + "static/media/nothingFound.188992db97ce6a288443d6cbf18b45ca.svg";
export { ForwardRef as ReactComponent };